const { createApp, ref, computed, component, watch, onMounted, reactive, onBeforeMount, onUnmounted } = Vue;
let currentGeolocation = null;
const aroma360Domains = [
  { country: "United States", domain: "eroma360.com" },
  { country: "Australia", domain: "www.aroma360.au" },
  { country: "Austria", domain: "at-aroma360.glopalstore.com" },
  { country: "Belgium", domain: "be-aroma360.glopalstore.com" },
  { country: "Brazil", domain: "www.aroma360official.com.br" },
  { country: "Canada", domain: "www.myaroma360.ca" },
  { country: "Czech Republic", domain: "cz-aroma360.glopalstore.com" },
  { country: "Denmark", domain: "www.aroma360.dk" },
  { country: "France", domain: "www.aroma360.fr" },
  { country: "Germany", domain: "www.aroma360.de" },
  { country: "India", domain: "www.myaroma360.in" },
  { country: "Ireland", domain: "ie-aroma360.glopalstore.com" },
  { country: "Italy", domain: "www.aroma360.it" },
  { country: "Japan", domain: "www.aroma360official.jp" },
  { country: "Mexico", domain: "www.aroma360.mx" },
  { country: "Netherlands", domain: "www.aroma360.nl" },
  { country: "Norway", domain: "www.aroma360.no" },
  { country: "Poland", domain: "www.aroma360.pl" },
  { country: "Saudi Arabia", domain: "sa-aroma360.glopalstore.com" },
  { country: "South Africa", domain: "www.aroma360.co.za" },
  { country: "Spain", domain: "www.aroma360.es" },
  { country: "Sweden", domain: "www.aroma360.se" },
  { country: "Switzerland", domain: "www.aroma360.ch" },
  { country: "Taiwan", domain: "www.aroma360.tw" },
  { country: "United Arab Emirates", domain: "www.aroma360.ae" },
  { country: "United Kingdom", domain: "www.aroma360.uk" },
  { country: "Singapore", domain: "sg-aroma360.glopalstore.com" },
  { country: "Åland Islands", domain: "ax-aroma360.glopalstore.com" },
  { country: "Albania", domain: "al-aroma360.glopalstore.com" },
  { country: "Algeria", domain: "dz-aroma360.glopalstore.com" },
  { country: "Andorra", domain: "ad-aroma360.glopalstore.com" },
  { country: "Argentina", domain: "ar-aroma360.glopalstore.com" },
  { country: "Azerbaijan", domain: "az-aroma360.glopalstore.com" },
  { country: "Bahamas", domain: "bs-aroma360.glopalstore.com" },
  { country: "Bahrain", domain: "bh-aroma360.glopalstore.com" },
  { country: "Barbados", domain: "bb-aroma360.glopalstore.com" },
  { country: "Belarus", domain: "by-aroma360.glopalstore.com" },
  { country: "Bermuda", domain: "bm-aroma360.glopalstore.com" },
  { country: "Bolivia", domain: "bo-aroma360.glopalstore.com" },
  {
    country: "Bosnia and Herzegovina",
    domain: "ba-aroma360.glopalstore.com",
  },
  { country: "Bulgaria", domain: "bg-aroma360.glopalstore.com" },
  { country: "Cambodia", domain: "kh-aroma360.glopalstore.com" },
  { country: "Cayman Islands", domain: "ky-aroma360.glopalstore.com" },
  { country: "Chile", domain: "cl-aroma360.glopalstore.com" },
  { country: "China", domain: "cn-aroma360.glopalstore.com" },
  { country: "Colombia", domain: "co-aroma360.glopalstore.com" },
  { country: "Costa Rica", domain: "cr-aroma360.glopalstore.com" },
  { country: "Croatia", domain: "hr-aroma360.glopalstore.com" },
  { country: "Cyprus", domain: "cy-aroma360.glopalstore.com" },
  { country: "Dominican Republic", domain: "do-aroma360.glopalstore.com" },
  { country: "Ecuador", domain: "ec-aroma360.glopalstore.com" },
  { country: "Egypt", domain: "eg-aroma360.glopalstore.com" },
  { country: "Estonia", domain: "ee-aroma360.glopalstore.com" },
  { country: "Faroe Islands", domain: "fo-aroma360.glopalstore.com" },
  { country: "Finland", domain: "fi-aroma360.glopalstore.com" },
  { country: "Georgia", domain: "ge-aroma360.glopalstore.com" },
  { country: "Ghana", domain: "gh-aroma360.glopalstore.com" },
  { country: "Gibraltar", domain: "gi-aroma360.glopalstore.com" },
  { country: "Greece", domain: "gr-aroma360.glopalstore.com" },
  { country: "Guatemala", domain: "gt-aroma360.glopalstore.com" },
  { country: "Guernsey", domain: "gg-aroma360.glopalstore.com" },
  { country: "Hong Kong", domain: "hk-aroma360.glopalstore.com" },
  { country: "Hungary", domain: "hu-aroma360.glopalstore.com" },
  { country: "Iceland", domain: "is-aroma360.glopalstore.com" },
  { country: "Indonesia", domain: "id-aroma360.glopalstore.com" },
  { country: "Isle of Man", domain: "im-aroma360.glopalstore.com" },
  { country: "Israel", domain: "il-aroma360.glopalstore.com" },
  { country: "Jamaica", domain: "jm-aroma360.glopalstore.com" },
  { country: "Jersey", domain: "je-aroma360.glopalstore.com" },
  { country: "Jordan", domain: "jo-aroma360.glopalstore.com" },
  { country: "Kazakhstan", domain: "kz-aroma360.glopalstore.com" },
  { country: "Kenya", domain: "ke-aroma360.glopalstore.com" },
  { country: "Kuwait", domain: "kw-aroma360.glopalstore.com" },
  { country: "Latvia", domain: "lv-aroma360.glopalstore.com" },
  { country: "Liechtenstein", domain: "li-aroma360.glopalstore.com" },
  { country: "Lithuania", domain: "lt-aroma360.glopalstore.com" },
  { country: "Luxembourg", domain: "lu-aroma360.glopalstore.com" },
  { country: "North Macedonia", domain: "mk-aroma360.glopalstore.com" },
  { country: "Malaysia", domain: "my-aroma360.glopalstore.com" },
  { country: "Malta", domain: "mt-aroma360.glopalstore.com" },
  { country: "Moldova", domain: "md-aroma360.glopalstore.com" },
  { country: "Monaco", domain: "mc-aroma360.glopalstore.com" },
  { country: "Mongolia", domain: "mn-aroma360.glopalstore.com" },
  { country: "Montenegro", domain: "me-aroma360.glopalstore.com" },
  { country: "Morocco", domain: "ma-aroma360.glopalstore.com" },
  { country: "Mozambique", domain: "mz-aroma360.glopalstore.com" },
  { country: "New Zealand", domain: "nz-aroma360.glopalstore.com" },
  { country: "Nicaragua", domain: "ni-aroma360.glopalstore.com" },
  { country: "Nigeria", domain: "ng-aroma360.glopalstore.com" },
  { country: "Oman", domain: "om-aroma360.glopalstore.com" },
  { country: "Panama", domain: "pa-aroma360.glopalstore.com" },
  { country: "Papua New Guinea", domain: "pg-aroma360.glopalstore.com" },
  { country: "Peru", domain: "pe-aroma360.glopalstore.com" },
  { country: "Philippines", domain: "ph-aroma360.glopalstore.com" },
  { country: "Portugal", domain: "pt-aroma360.glopalstore.com" },
  { country: "Qatar", domain: "qa-aroma360.glopalstore.com" },
  { country: "Romania", domain: "ro-aroma360.glopalstore.com" },
  { country: "San Marino", domain: "sm-aroma360.glopalstore.com" },
  { country: "Serbia", domain: "rs-aroma360.glopalstore.com" },
  { country: "Slovakia", domain: "sk-aroma360.glopalstore.com" },
  { country: "Slovenia", domain: "si-aroma360.glopalstore.com" },
  { country: "South Korea", domain: "kr-aroma360.glopalstore.com" },
  { country: "Tanzania", domain: "tz-aroma360.glopalstore.com" },
  { country: "Thailand", domain: "th-aroma360.glopalstore.com" },
  { country: "Trinidad and Tobago", domain: "tt-aroma360.glopalstore.com" },
  { country: "Tunisia", domain: "tn-aroma360.glopalstore.com" },
  { country: "Turkey", domain: "tr-aroma360.glopalstore.com" },
  { country: "Uganda", domain: "ug-aroma360.glopalstore.com" },
  { country: "Uruguay", domain: "uy-aroma360.glopalstore.com" },
  { country: "Vietnam", domain: "vn-aroma360.glopalstore.com" },
  { country: "Zambia", domain: "zm-aroma360.glopalstore.com" },
];
const urlHostname = window.location.hostname;
const countryDomainMap = aroma360Domains.find((d) => d.domain === urlHostname);
let productInfoSection = document.querySelector(".section-product-info");
let sectionId = productInfoSection.id;
let splitSectionId = sectionId.split(":").pop().replace("shopify-section-", "");
let productInfoSectionId = `eurus:product-page-variant-select:updated:${splitSectionId}`;

const paymentOptionsApp = createApp({
  name: "PaymentOptionsApp",
  setup() {
    const paymentOptionsData = ref(paymentOptionsDataObj);
    const isLoading = ref(false);
    const AtcPayload = ref([]);
    const isSubmitting = ref(false);
    const currentActiveBlock = ref("");
    const doesSubAdnExist = ref(false);
    const addOnQty = ref(1);
    const redirectToCheckout = ref(false);
    const eventsAttachedToAtc = ref(false);
    const redirectToLp = ref(null);
    const currentMainProductVarId = ref(null);

    const giftComparePrice = computed(() => {
      const product = paymentOptionsData.value?.gift_add_on?.product;
      if (!product) return 0;
      return product.compare_at_price || product.price || 0;
    });

    let variantInputEl = null;

    onBeforeMount(() => {
      const blocks = paymentOptionsData.value.blocks;
      const filteredBlocks = blocks.filter(b => shouldRenderBlock(b?.blacklist || []));
      paymentOptionsData.value.blocks = filteredBlocks;
    });

    onMounted(async () => {
      isLoading.value = true;
      let paymentBlocks = paymentOptionsData.value.blocks;
      if (paymentOptionsData.value.blocks?.length) {
        renderAdditionalTagOrPriceOnMount(paymentOptionsData.value.blocks);
      }

      paymentOptionsData.value.blocks = paymentBlocks.map((pb) => {
        try {
          let sellingPlanName = "every 30 days.";

          if (pb.type === "multi_add_on_block" && pb.add_on_select_mode === 'multiple') {
            // for quarterly subscription
            sellingPlanName = "Delivered every 90 days.";
          }

          if (pb.type === "pay_in_full" || pb.type === "product_bundle_layout" || pb.type === "multi_add_on_block") {
            pb.add_ons = pb.add_ons.map((a) => {
              if (!a.hidden) {
                a.products = a.products.map((p) => {
                  p.og_selling_plan_id = getSellingPlanId(p.selling_plan_allocations, sellingPlanName);
									p.annual_selling_plan_id = getSellingPlanId(p.selling_plan_allocations, "30 days, prepaid");
                  p.price_info = calculateDiscount(p, pb.type);
                  // if (a.additional_discount) {
                  //   // exclusive for quarterly subscription
                  //   p.additional_discount = Number(a.additional_discount);
                  // }
                  return p;
                });
              }
              return a;
            });
          }

          if (pb.type === "steps_block") {
						pb.options = pb.options.map(o => {
							if (o.type !== "MAIN_PRODUCT_ONLY") {
								o.add_ons = o.add_ons.map((a) => {
									if (!a.hidden) {
										a.products = a.products.map((p) => {
											p.og_selling_plan_id = getSellingPlanId(p.selling_plan_allocations, sellingPlanName);
											p.annual_selling_plan_id = getSellingPlanId(p.selling_plan_allocations, "30 days, prepaid");
											p.price_info = calculateDiscount(p, pb.type);
											return p;
										});
									}
									return a;
								});
							}
							return o;
						});
					}
          return pb;
        } catch (error) {
          console.error(error, "Error fetching OG info");
        }
      });

      variantInputEl = document.getElementById("pb_variant_id");
     currentMainProductVarId.value = variantInputEl ? variantInputEl.value : null;
      if (!countryDomainMap) {
        await loadCurrentLocation().catch((reject) => {
          console.warn(reject, "=>", "Rebuy Geolocation took too long to respond or not loaded.");
        });
      }
      isLoading.value = false;
    });

    onBeforeMount(() => {
      document.addEventListener(productInfoSectionId, () => {
        variantInputEl = document.querySelector(".form input[name='id']");
        const qtySelectorEl = document.querySelector(".product-form__quantity-selector input[type='number']");
        currentMainProductVarId.value = variantInputEl ? variantInputEl.value : null;

        if (currentActiveBlock.value === "") {
          setTimeout(() => {
            updateMainProductLinePrice(
              {
                sale_price: window.mainProductPrice.sale_price,
                discount_price: window.mainProductPrice.discount_price,
                savings: window.mainProductPrice.savings,
              },
              "PaymentOptionsApp"
            );
          }, 10);
        }

        if (qtySelectorEl) {
          // This is needed since alpine is interfering with vue
          setTimeout(() => {
            qtySelectorEl.value = addOnQty.value;
          }, 20);
        }
      });

      reHookEventsOnAtcBtn();
    });

    function getSellingPlanId(plans = [], frequency = "") {
      let annualSellingPlanId = null;
      // 30-day plans were replaced by 4-week plans; match either wording.
      const frequencies = [frequency];
      const weekAlias = { "30 days": "4 weeks", "60 days": "8 weeks", "90 days": "12 weeks" };
      Object.keys(weekAlias).forEach((d) => {
        if (frequency.includes(d)) frequencies.push(frequency.replace(d, weekAlias[d]));
      });
      for (let i = 0; i < plans.length; i++) {
        let sellingPlanAllocation = plans[i];
        let sellingPlan = sellingPlanAllocation.selling_plan;

        if (
          sellingPlan.recurring_deliveries &&
          sellingPlan.name.includes("Delivered") &&
          frequencies.some((f) => sellingPlan.name.includes(f))
        ) {
          annualSellingPlanId = sellingPlan.id;
          break; // exit the loop
        }
      }
      return annualSellingPlanId;
    }

    function loadCurrentLocation(attempt = 0) {
      try {
        const maxAttempts = 5;
        return new Promise((resolve, reject) => {
          if (attempt >= maxAttempts) {
            reject("Max attempts reached.");
            return;
          }

          if (
            typeof Rebuy !== "undefined" &&
            Rebuy._status === "initialized" &&
            typeof Rebuy.getGeolocation === "function"
          ) {
            Rebuy.getGeolocation()
              .then((resp) => {
                currentGeolocation = resp;
                resolve(currentGeolocation);
              })
              .catch((error) => {
                reject(error);
              });
          } else {
            setTimeout(() => {
              loadCurrentLocation(attempt + 1)
                .then(resolve)
                .catch(reject);
            }, 1000);
          }
        });
      } catch (error) {
        console.log(error);
      }
    }

    watch(currentActiveBlock, () => {
      AtcPayload.value = [];
    });

    watch(AtcPayload, () => {
      doesSubAdnExist.value = AtcPayload.value.some((p) => p.selling_plan);
    });

    watch(isSubmitting, () => handleATCLoading());

    function reHookEventsOnAtcBtn() {
      try {
        const mutationHandler = function (mutationsList, observer) {
          for (let mutation of mutationsList) {
            if (mutation.type === "childList" && mutation.addedNodes.length > 0) {
              const atcBtn = document.querySelector('.AddToCart');
              const qtySelector = document.querySelector(".product-form__quantity-selector");
              const stickyATC = document.querySelector(".StickyAddToCart");
              
              if (atcBtn === mutation.target && atcBtn.querySelector("span.loader-button__text")) {
                observer.disconnect();
                let clonedAtcBtn = atcBtn.cloneNode(true);
                let clonedQtySelector = null;

                for (let attr of Array.from(clonedAtcBtn.attributes)) {
                  if (attr.name.startsWith("x-intersect") || attr.name == "@click") {
                    clonedAtcBtn.removeAttribute(attr.name);
                  }
                }

                clonedAtcBtn.setAttribute("type", "button");
                atcBtn.parentNode.replaceChild(clonedAtcBtn, atcBtn);
                clonedAtcBtn.addEventListener("click", handleAddToCart);

                if (qtySelector) {
                  clonedQtySelector = qtySelector.cloneNode(true);
                  let qtySelectorBtns = clonedQtySelector.querySelectorAll("button");
                  let qtySelectorInput = clonedQtySelector.querySelector("input[type='number']");

                  for (let attr of Array.from(clonedQtySelector.attributes)) {
                    if (attr.name.startsWith("x-data")) {
                      clonedQtySelector.removeAttribute(attr.name);
                    }
                  }
                  
                  for (let btn of qtySelectorBtns) {
                    btn.setAttribute('type', 'button');
                    for (let attr of Array.from(btn.attributes)) {
                      if (attr.name.startsWith("@click.prevent")) {
                        btn.removeAttribute(attr.name);
                      }
                    }
                  }

                  for (let attr of Array.from(qtySelectorInput.attributes)){
                    if (attr.name.startsWith("x-model") || attr.name.startsWith("x-on:blur")) {
                      qtySelectorInput.removeAttribute(attr.name);
                    }
                  }

                  qtySelector.parentNode.replaceChild(clonedQtySelector, qtySelector);
                  reHookEventsOnQtyBtns();
                }

                if (stickyATC) {
                  stickyATC.addEventListener("click", function (event) {
                    event.preventDefault();
                    if (paymentOptionsData.value.main_product.tags.includes("form_anchor")) {
                      const leadFormElement = document.getElementById("LeadForm");
											const elementPosition = leadFormElement.getBoundingClientRect().top;
											const offsetPosition = elementPosition + window.pageYOffset - 350;
                      window.scrollTo({
                        top: offsetPosition,
                        behavior: "smooth",
                      });
                    } else {
                      clonedAtcBtn.click();
                    }
                  });
                }

                if (paymentOptionsData.value?.hide_default_atc) {
                  clonedAtcBtn.style.display = "none";
                  if(clonedQtySelector) clonedQtySelector.style.display = "none";
                  if (paymentOptionsData?.value?.main_product?.tags?.includes("form_anchor") === false && stickyATC) {
                      stickyATC.style.display = "none";
                  }
                }

                eventsAttachedToAtc.value = true;
              }
            }
          }
        };
        const observer = new MutationObserver(mutationHandler);
        observer.observe(document.body, { childList: true, subtree: true });
      } catch (error) {
        console.log(error);
      }
    }

    function reHookEventsOnQtyBtns() {
    	let qtySelector = document.querySelector(".product-form__quantity-selector");
    	if (qtySelector) {
        let qtySelectorBtns = qtySelector.querySelectorAll("button");
        for (let btn of qtySelectorBtns) {
          if (btn.getAttribute("name") === 'minus') {
            btn.addEventListener("click", () => handleQtySelect("-"));
          }

          if (btn.getAttribute("name") === 'plus') {
            btn.addEventListener("click", () => handleQtySelect("+"));
          }
        }
    		qtySelector.querySelector("input[type='number']").style["pointer-events"] = "none";
    	}
    }

    function handleQtySelect(action) {
      const qtySelectorEl = document.querySelector(".product-form__quantity-selector input[type='number']");
      let currencyQty = addOnQty.value;

      if (action === "+") {
        currencyQty += 1;
      }

      if (action === "-") {
        currencyQty = currencyQty > 1 ? currencyQty - 1 : 1;
      }

      if (qtySelectorEl) {
        qtySelectorEl.value = currencyQty;
      }

      addOnQty.value = currencyQty;
    }

    function handleATCLoading() {
      let atcBtn = document.querySelector(".AddToCart");
      const stickyATC = document.querySelector(".StickyAddToCart");
      if (isSubmitting.value) {
        atcBtn.setAttribute("aria-busy", true);
        atcBtn.setAttribute("disabled", true);
        // stickyATC.setAttribute("aria-busy", true);
        // stickyATC.setAttribute("disabled", true);
      } else {
        atcBtn.removeAttribute("aria-busy");
        atcBtn.removeAttribute("disabled");
        // stickyATC.removeAttribute("aria-busy");
        // stickyATC.removeAttribute("disabled");
      }
    }

    const GIFT_PROMO_SOURCE = "car-diffuser-set-promo";

    function getGiftAddOnVariantId(giftAddOn) {
      const product = giftAddOn?.product;
      if (!product) return null;
      if (Array.isArray(product.variants) && product.variants[0]?.id) {
        return product.variants[0].id;
      }
      return product.id || null;
    }

    function withGiftPromoSource(properties = {}, giftAddOn) {
      if (!giftAddOn) return { ...properties };
      return { ...properties, _promotional_source: GIFT_PROMO_SOURCE };
    }

    async function handleAddToCart() {
      const compare_at_price_property = document.getElementById("line-item-custom-property");
      const compare_at_price_percentage_property = document.getElementById("line-item-custom-property-percentage");
      const timesact_element = document.querySelector("input[data-timesact-selling-plan]");

      if (redirectToLp.value) {
        window.location.href = redirectToLp.value;
        return;
      }
      isSubmitting.value = true;

      let properties = {};
      // getting the lineitem property from the current active payment block
      const lineItemProperty = paymentOptionsData.value.blocks.find(
        (b) => b.id === currentActiveBlock.value
      )?.line_item_property;
      const bundleIdProperty = paymentOptionsData.value.blocks.find(
        (b) => b.id === currentActiveBlock.value
      )?.bundle_id;
      let bundleId = null;
      const giftAddOn = paymentOptionsData.value.gift_add_on;
      const giftVariantId = getGiftAddOnVariantId(giftAddOn);
      if (lineItemProperty) {
        properties[lineItemProperty] = true;
      }
      properties = withGiftPromoSource(properties, giftAddOn);

      if (bundleIdProperty) {
        const uniqueId = [bundleIdProperty, currentMainProductVarId.value];
        AtcPayload.value.forEach((p) => {
          uniqueId.push(p.id);
          if (p.selling_plan) {
            uniqueId.push(`plan_30`);
          }
        });
        uniqueId.push(`ts_${Date.now()}`);
        bundleId = uniqueId.join("_");
      }

      if (bundleId) {
        properties["_bundle_id"] = bundleId;
      }

      try {
        window.setATCErrorMessage("");
        let mainProduct = {
          quantity: addOnQty.value,
          id: parseInt(currentMainProductVarId.value),
          properties,
        };
        if (compare_at_price_percentage_property && compare_at_price_property) {
          mainProduct.properties = {
            ...mainProduct.properties,
            _compare_at_price: compare_at_price_property.value,
            _compare_at_price_discount: compare_at_price_percentage_property.value,
          };
        }
        if(timesact_element && timesact_element.value){
          mainProduct = {...mainProduct, selling_plan: timesact_element.value, properties: {...mainProduct.properties, _timesact_preorder: true}}
        }
        let atcProducts = AtcPayload.value.map((p) => {
          let properties = p.properties || {};
          if (lineItemProperty) {
            properties[lineItemProperty] = true;
          }

          if (bundleId) {
            properties["_bundle_id"] = bundleId;
            properties["_bundle_identifier"] = "true";
          }

          if (
            giftAddOn &&
            (Number(p.id) === Number(giftVariantId) ||
              Number(p.id) === Number(giftAddOn.product?.id) ||
              p.properties?._discount_settings)
          ) {
            properties = withGiftPromoSource(properties, giftAddOn);
          }

          return {
            ...p,
            quantity: addOnQty.value,
            properties,
          };
        });

        if (
          giftAddOn &&
          giftVariantId &&
          !atcProducts.some(
            (p) =>
              Number(p.id) === Number(giftVariantId) ||
              Number(p.id) === Number(giftAddOn.product?.id)
          )
        ) {
          atcProducts.push({
            id: giftVariantId,
            quantity: addOnQty.value,
            properties: withGiftPromoSource({}, giftAddOn),
          });
        }
        const widget = window.Rebuy.widgets.find(
          (widget) => widget.id === "52434" || widget.id === "201848"
        );
        if (widget) {
          const oilInCart = Rebuy.Cart.cart.items.find(item => item.product_type === 'Oil');
          if (atcProducts.length || oilInCart) {
            widget.detachWidget();
          }
        }
        //console.log({mainProduct, atcProducts },"add to cart working");
        if (redirectToCheckout.value) Rebuy.SmartCart.skip_open = true;
        const response = await fetch(window.Shopify.routes.root + "cart/add.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ items: [mainProduct, ...atcProducts] }),
          });
        const data = await response.json();
        if (response.status !== 200) {
          if (data.message) {
            return window.setATCErrorMessage(data.message);
          }
        }
        if (data && redirectToCheckout.value) {
          let str = window.location.href.includes("/es/") ? "?locale=es" : "";
          str = "/checkout" + str;
          window.location.href = str;
        }
      } catch (error) {
        console.log(error);
        window.setATCErrorMessage("Oops! Something went wrong while adding products to the cart.");
      } finally {
        isSubmitting.value = false;
      }
    }

    async function getOGSellingPlans(productId) {
      try {
        let resp = await fetch(
          `https://us-central1-shopify-web-dev.cloudfunctions.net/getOGIncentive?productId=${productId}`,
          {
            method: "GET",
          }
        );
        return resp.json();
      } catch (error) {
        console.log(error);
      }
    }
    function handleBlockSelect(e, checkout_label, checkout_redirect, isOos, landing_page_redirect) {
      if(typeof window.killPriceLogicVariantListener === "function") window.killPriceLogicVariantListener();
      currentActiveBlock.value = e;
      let atcBtn = document.querySelector(".AddToCart");
      if (!atcBtn) return;
      let atcBtnInrTxt = atcBtn.querySelector("span.loader-button__text");
      atcBtn.classList.remove("sold-out");
      atcBtn.removeAttribute("disabled");
      if (checkout_label !== undefined && checkout_label !== null && checkout_label !== "") {
        if (atcBtnInrTxt) atcBtnInrTxt.textContent = checkout_label;
        // updating this attribute will prevent default behivour of theme to update the button text based on variant change
        atcBtn.setAttribute("data-button-content", checkout_label);
      }
      if (checkout_redirect !== undefined && checkout_redirect !== null && checkout_redirect !== "") {
        redirectToCheckout.value = checkout_redirect;
      }

      redirectToLp.value = null;
      if (landing_page_redirect && typeof landing_page_redirect === "string") {
        redirectToLp.value = landing_page_redirect;
      }

      if ((typeof isOos === "boolean" && isOos) || !checkMainProductAvailablility()) {
        if (atcBtnInrTxt) atcBtnInrTxt.textContent = "Out of Stock";
        atcBtn.setAttribute("data-button-content", "Out of Stock");
        atcBtn.classList.add("sold-out");
        atcBtn.setAttribute("disabled", "");
      }
    }

    function checkMainProductAvailablility() {
      let selectedVariantId = currentMainProductVarId.value;
      const filteredMainProdVariant = paymentOptionsData.value.main_product.variants.find(
        (item) => item.id === +selectedVariantId
      );
      return filteredMainProdVariant ? filteredMainProdVariant.available : false;
    }

    function handleBlockUnSelect(e) {
      try {
        if(typeof window.refreshPriceLogicVariantListener === "function") window.refreshPriceLogicVariantListener();
        if (paymentOptionsData.value.block_input_type === "checkbox") {
          let atcBtn = document.querySelector(".AddToCart");
          if (!atcBtn) return;
          let atcBtnInrTxt = atcBtn.querySelector("span.loader-button__text");
          currentActiveBlock.value = "";
          if (atcBtnInrTxt) atcBtnInrTxt.textContent = "ADD TO CART";
          atcBtn.setAttribute("data-button-content", "ADD TO CART");
          if (redirectToLp.value) {
            redirectToLp.value = null;
          }
          updateMainProductLinePrice(
            {
              sale_price: window.mainProductPrice.sale_price,
              discount_price: window.mainProductPrice.discount_price,
              savings: window.mainProductPrice.savings,
            },
            undefined
          );
          renderAdditionalTagOrPriceOnMount(paymentOptionsData.value.blocks);
        }
      } catch (error) {
        console.error(error);
      }
    }

    function handeLineItemDispatch(e) {
      AtcPayload.value = e;
    }

    function hasBlackListedVariant(blackList = [], blockType) {
      if (blackList && blackList.length && blackList.includes(currentMainProductVarId.value)) {
        if (blockType === currentActiveBlock.value) {
          currentActiveBlock.value = "";
          const currentVariant = paymentOptionsData.value.main_product.variants.find(
            (v) => v.id === parseInt(currentMainProductVarId.value)
          );
          handleBlockSelect("", "ADD TO CART", false, !currentVariant.available, undefined);
          updateMainProductLinePrice(
            {
              sale_price: window.mainProductPrice.sale_price,
              discount_price: window.mainProductPrice.discount_price,
              savings: window.mainProductPrice.savings,
            },
            blockType
          );
        }
        return true;
      }
      return false;
    }

    return {
      paymentOptionsData,
      isLoading,
      currentActiveBlock,
      currentMainProductVarId,
      hasBlackListedVariant,
      shouldRenderBlock,
      handleBlockSelect,
      handleBlockUnSelect,
      handeLineItemDispatch,
      checkMainProductAvailablility,
      AtcPayload,
      addOnQty,
      doesSubAdnExist,
      eventsAttachedToAtc,
      giftComparePrice,
      formatMoneyy,
    };
  },
  delimiters: ["${", "}"],
});

paymentOptionsApp.component("pb-pay-in-full", {
  template: "#payInFullBlock",
  emits: ["on-block-select", "on-line-item-dispatch", "on-block-unselect"],
  props: ["block_data", "block_active", "is_preselected", "payment_options_data", "input_type"],
  setup(props, ctx) {
    const doesSubAdnExist = ref(false);
    const isOutOfStock = ref(false);
    const morePerksBtnElRef = ref(null);
    const blockAddOnState = ref(
			props.block_data.add_ons
				.filter((a) => !a.hidden)
				.map((a) => {
					return {
						id: a.id,
						data: [],
					};
				})
		);
    const headerBlockPrice = ref({
      sale_price: 0,
      discount_price: 0,
      savings: [],
    });
    const discountForMainProductFrmAdnArr = ref(initBlockHeaderDiscount());
    const blockHiddenAddOnState = ref(
      props.block_data.add_ons
        .filter((a) => a.hidden)
        .map((a) => {
          return a.products;
        })
        .flat()
    );
    const annualPrepaidInfo = ref({});

    // watcher callback runs on when block selected/unselected
    watch(
      () => props.block_active,
      () => {
        if (!props.block_active) {
          doesSubAdnExist.value = false;
          // reset block head price to default state
          discountForMainProductFrmAdnArr.value = initBlockHeaderDiscount();
          blockAddOnState.value = blockAddOnState.value.map((a) => ({
            ...a,
            data: [],
          }));
        } else {
          updateBlockHeaderPriceInfo();
          if (props.is_preselected) {
            dispatchLineItems();
          }
        }
      }
    );

    watch(blockAddOnState, () => {
      if (props.block_active) {
        dispatchLineItems();
        // update the addon discount on addon state changes when current block is active
        discountForMainProductFrmAdnArr.value = discountForMainProductFrmAdnArr.value.map((d) => {
            let activeAdn = blockAddOnState.value.find((b) => b.id === d.id);
            if (
              activeAdn.data.length &&
              activeAdn.data[0].purchase_type === "SUBSCRIPTION" &&
              (activeAdn.data[0]?.enable_discount === "SUBSCRIPTION" || activeAdn.data[0]?.enable_discount === "BOTH")
            ) {
              return {
                id: d.id,
                discount_value: parseFloat(activeAdn.data[0].subscription_discount_value),
							  discount_value_type: activeAdn.data[0].subscription_discount_value_type,
              };
            }
            if (
              activeAdn.data.length &&
              activeAdn.data[0].purchase_type === "ONE_TIME" &&
              (activeAdn.data[0]?.enable_discount === "ONE_TIME" || activeAdn.data[0]?.enable_discount === "BOTH")
            ) {
              return {
                id: d.id,
                discount_value: parseFloat(activeAdn.data[0].one_time_discount_value),
                discount_value_type: activeAdn.data[0].one_time_discount_value_type,
              };
            }
            //console.log(activeAdn.data.length,activeAdn.data[0].purchase_type,activeAdn.data[0]?.enable_discount,"annual prepaid if conditions");
            if (
              activeAdn.data.length &&
              activeAdn.data[0].purchase_type === "ANNUAL_PREPAID" &&
              activeAdn.data[0]?.enable_discount === "ANNUAL_PREPAID"
            ) {
              //console.log("annual prepaid");
              return {
                id: d.id,
                discount_value: parseFloat(activeAdn.data[0].annual_prepaid_discount_value),
							discount_value_type: activeAdn.data[0].annual_prepaid_discount_value_type,
              };
            }
            return {
              id: d.id,
              discount_value: 0,
              discount_value_type: "PERCENTAGE",
            };
          });
      }
      doesSubAdnExist.value = blockAddOnState.value
        .map((a) => a.data)
        .flat()
        .some((p) => p.purchase_type === "SUBSCRIPTION" || p.purchase_type === "ANNUAL_PREPAID");
      updateBlockHeaderPriceInfo();
    });

    onMounted(() => {
      updateBlockHeaderPriceInfo();
      isOutOfStock.value = props.block_data.add_ons
        .map((a) => {
          return a.product || a.products;
        })
        .flat()
        .some((p) => p.availble === false);
      document.addEventListener(productInfoSectionId, variantChangedHandler);
      if (props.is_preselected) {
        //console.log(props.is_preselected,"preselected");
        ctx.emit(
          "on-block-select",
          props.block_data.id,
          props.block_data.add_to_cart_label,
          props.block_data.redirect_to_checkout,
          isOutOfStock.value
        );
      }
      updateAnnualPrepaidInfo();
      // updateTopLinePrice();
      if (morePerksBtnElRef.value) {
        morePerksBtnElRef.value.addEventListener("click", perksPopupToggleHandler);
      }
    });

    function perksPopupToggleHandler(e) {
      const modal = document.getElementById("perks-modal-pricing-modal");
      const closeModalBtn = document.querySelector(".perks-modal-close-btn");

      modal.style.display = "flex";

      // Close the modal when clicking the close button
      closeModalBtn.addEventListener("click", () => {
        modal.style.display = "none";
      });

      // Close the modal when clicking outside the modal content
      window.addEventListener("click", (e) => {
        if (e.target === modal) {
          modal.style.display = "none";
        }
      });
    }

    function updateAnnualPrepaidInfo() {
      const firstAvailableProduct = props.block_data.add_ons
        .find((a) => a.type === "add_on")
        .products.find((p) => p.available);
      if (props.block_data.show_annual_plan_ui && firstAvailableProduct) {
        const annualPlanSavings = {};
        const addonProductBasePrice = firstAvailableProduct.compare_at_price
          ? firstAvailableProduct.compare_at_price
          : firstAvailableProduct.price;
        const freeAddon = props.block_data.add_ons.find((a) => a.type === "gift_add_on");
        const offerMonths = props.block_data?.annual_plan_free_months_offer || 0;
				const annualPrepaidDiscount = parseFloat(props.block_data?.annual_plan_discount) || 0;
        const totalBasePrice = addonProductBasePrice * 12;
        const billedToday = getTotalAnnualPrepaidPrice(firstAvailableProduct) || totalBasePrice;
        const salePriceOveride = parseFloat(props.block_data.sale_price) || 0;

        annualPlanSavings.free_diffuser = parseFloat(
          window.mainProductPrice.discount_price || window.mainProductPrice.sale_price
        );
        annualPlanSavings.total_savings = 0;

        if (salePriceOveride) {
          annualPlanSavings.total_savings += annualPlanSavings.free_diffuser;
        }

        if (offerMonths) {
          // console.log(totalBasePrice, "annual base price", annualPrepaidDiscount);
          annualPlanSavings.annual_free_offer = totalBasePrice * (annualPrepaidDiscount / 100);
					annualPlanSavings.total_savings += annualPlanSavings.annual_free_offer;
        }

        if (billedToday) {
          annualPlanSavings.billed_today = billedToday;
        }

        if (freeAddon && freeAddon.product) {
          const giftAddonPrice = freeAddon.product.compare_at_price || freeAddon.product.price;
          annualPlanSavings.free_addon = {
            text: freeAddon.label,
            price: giftAddonPrice,
          };
          annualPlanSavings.total_savings += giftAddonPrice;
        }

        if (props.block_data?.annual_plan_shipping_discount) {
          annualPlanSavings.free_shipping_value = parseFloat(props.block_data?.annual_plan_shipping_discount * 100);
					annualPlanSavings.total_savings += annualPlanSavings.free_shipping_value;
        }

        annualPrepaidInfo.value = annualPlanSavings;
      }
    }

    function getTotalAnnualPrepaidPrice(product) {
      if (product) {
        const sellingPlan = product.selling_plan_allocations.find((s) =>
          s.selling_plan.name.includes("30 days, prepaid for 12 shipments") ||
          s.selling_plan.name.includes("4 weeks, prepaid for 12 shipments")
        );
        return sellingPlan?.price;
      }
      return 0;
    }

    function variantChangedHandler(e) {
      if (props.block_active) {
        ctx.emit(
          "on-block-select",
          props.block_data.id,
          props.block_data.add_to_cart_label,
          props.block_data.redirect_to_checkout,
          isOutOfStock.value
        );
        updateBlockHeaderPriceInfo();
      }
    }

    onUnmounted(() => {
      document.removeEventListener(productInfoSectionId, variantChangedHandler);
    });

    function updateBlockHeaderPriceInfo() {
      const overidePrice = parseFloat(props.block_data.original_price) * 100 || 0;
			const overideSalePriceDiscount = parseFloat(props.block_data.sale_price) || 0;
      const priceRenderMode = props.block_data.price_render_mode;
      let checkout_label = props.block_data.add_to_cart_label;
      let atcBtn = document.querySelector(".AddToCart");
      let atcBtnInrTxt = atcBtn.querySelector("span.loader-button__text");
      if (props.block_data.display_mode === "STARTER_KIT_V2") {
        atcBtn.classList.add("starter-kit-v2");
      }
      // getting top line price from global context.
      let salePrice = parseFloat(window.mainProductPrice.sale_price) || 0;
      let discountPrice = window.mainProductPrice.discount_price
        ? parseFloat(window.mainProductPrice.discount_price)
        : null;
      let saveLabel = [formatSavingsLabel(window.mainProductPrice.savings)];
      // overide product price
      if (overidePrice) {
        salePrice = overidePrice;
      }
      if (overideSalePriceDiscount) {
        discountPrice = calculateDiscountedPrice(salePrice, overideSalePriceDiscount);
        saveLabel = [formatSavingsLabel(overideSalePriceDiscount)];
        //console.log(discountPrice,overideSalePriceDiscount,saveLabel,"discount from pay in full overide");
      }

      let addOnTotalDiscount = calculateTotalAdnDiscount(discountForMainProductFrmAdnArr.value, salePrice);
      //console.log(addOnTotalDiscount,"addon total discount");
      discountPrice = calculateDiscountedPrice(salePrice, addOnTotalDiscount);
      if (addOnTotalDiscount) saveLabel = [formatSavingsLabel(addOnTotalDiscount)];
      //console.log(addOnTotalDiscount,discountPrice,saveLabel,"add on total discount and price");
      // if there is no addon discount fallback to default discount
      if (!addOnTotalDiscount) {
        discountPrice = window.mainProductPrice.discount_price
          ? parseFloat(window.mainProductPrice.discount_price)
          : null;
        if (overideSalePriceDiscount) {
          discountPrice = calculateDiscountedPrice(salePrice, overideSalePriceDiscount);
          saveLabel = [formatSavingsLabel(overideSalePriceDiscount)];
        }
        //console.log(discountPrice,overideSalePriceDiscount,saveLabel,"inside if there is no discount fallback");
      }

      // check if combined price is enabled if true then add the oil price with the main product price.
      if (priceRenderMode === "DISPLAY_COMBINED_PRICE") {
        // format the existing product label according to combined price.
        if (addOnTotalDiscount) {
          saveLabel = [`${addOnTotalDiscount.toFixed()}% OFF ${props.block_data.parent_product.title}`];
        } else {
          saveLabel = [`${window?.mainProductPrice?.savings} OFF ${props.block_data.parent_product.title}`];
        }

        let { totalSalePrice, totalDiscountPrice } = getTotalAddonPrice(blockAddOnState.value);
        if (!totalSalePrice && !totalDiscountPrice) {
          const tempAddOnState = props.block_data.add_ons
            .filter((a) => !a.hidden)
            .map((a) => {
              const tempProduct = getTempProductSelection(a);
              return {
                id: a.id,
                data: [tempProduct],
              };
            });
            ({ totalSalePrice, totalDiscountPrice } = getTotalAddonPrice(tempAddOnState));
        }

        salePrice = salePrice + totalSalePrice;
        //console.log(discountPrice, totalDiscountPrice, totalSalePrice, "discount", "addon discount", "total sale price");
        if (discountPrice != null && totalDiscountPrice) {
          discountPrice = discountPrice + totalDiscountPrice;
        } else if (!discountPrice && totalDiscountPrice) {
          discountPrice = Math.abs(salePrice - totalDiscountPrice);
        } else if (discountPrice != null && !totalDiscountPrice) {
          discountPrice = discountPrice + totalSalePrice;
        }

        headerBlockPrice.value.sale_price = salePrice;
        headerBlockPrice.value.discount_price = discountPrice;
        // updating label from addons when combined price is enabled.
        saveLabel = getSavingsLabelForAddons(saveLabel, blockAddOnState.value);
        saveLabel = renderAdditionalPromoLabelOrPrice(saveLabel, blockAddOnState.value, props.block_data);
        headerBlockPrice.value.savings = saveLabel;
        if (props.block_active) {
          updateMainProductLinePrice(headerBlockPrice.value, props.block_data.type);
        }
      } else if (priceRenderMode === "DISPLAY_COMBINED_PRICE_W_DISCOUNT") {
        let totalCombinedDiscount = null;
        saveLabel = [];
        let { totalSalePrice, totalDiscountPrice } = getTotalAddonPrice(blockAddOnState.value);
        if (!totalSalePrice && !totalDiscountPrice) {
          const tempAddOnState = props.block_data.add_ons
            .filter((a) => !a.hidden)
            .map((a) => {
              const tempProduct = getTempProductSelection(a);
              return {
                id: a.id,
                data: [tempProduct],
              };
            });
            ({ totalSalePrice, totalDiscountPrice } = getTotalAddonPrice(tempAddOnState));
        }

        salePrice = salePrice + totalSalePrice;
        //console.log(discountPrice, totalDiscountPrice, totalSalePrice, "discount", "addon discount", "total sale price");
        if (discountPrice != null && totalDiscountPrice) {
          discountPrice = discountPrice + totalDiscountPrice;
        } else if (!discountPrice && totalDiscountPrice) {
          discountPrice = Math.abs(salePrice - (totalSalePrice - totalDiscountPrice));
        } else if (discountPrice != null && !totalDiscountPrice) {
          discountPrice = discountPrice + totalSalePrice;
        }

        headerBlockPrice.value.sale_price = salePrice;
        headerBlockPrice.value.discount_price = discountPrice;
        totalCombinedDiscount = calculateDiscountPercentage(salePrice, discountPrice);
        // updating label from addons when combined price is enabled.
        if (totalCombinedDiscount) {
          saveLabel = [`${formatSavingsLabel(totalCombinedDiscount)}`];
          saveLabel = renderAdditionalPromoLabelOrPrice(saveLabel, blockAddOnState.value, props.block_data);
        }

        headerBlockPrice.value.savings = saveLabel;
        if (props.block_active) {
          updateMainProductLinePrice(headerBlockPrice.value, props.block_data.type);
        }
      } else if (priceRenderMode === "DISPLAY_ADD_ON_PRICE") {
        let { totalSalePrice, totalDiscountPrice } = getTotalAddonPrice(blockAddOnState.value);
        if (!totalSalePrice && !totalDiscountPrice) {
          const tempAddOnState = props.block_data.add_ons
            .filter((a) => !a.hidden)
            .map((a) => {
              const tempProduct = getTempProductSelection(a);
              return {
                id: a.id,
                data: [tempProduct],
              };
            });
            ({ totalSalePrice, totalDiscountPrice } = getTotalAddonPrice(tempAddOnState));
        }
        headerBlockPrice.value.sale_price = totalSalePrice;
        headerBlockPrice.value.discount_price = totalDiscountPrice || null;

        //Update the main product price with discounts
        if (props.block_active) {
          updateMainProductLinePrice(
            {
              sale_price: salePrice,
              discount_price: discountPrice,
              savings: renderAdditionalPromoLabelOrPrice(saveLabel, blockAddOnState.value, props.block_data),
            },
            props.block_data.type
          );
        }
      } else if (priceRenderMode === "DISPLAY_MAIN_PRODUCT_PRICE") {
        headerBlockPrice.value.sale_price = salePrice;
        headerBlockPrice.value.discount_price = discountPrice;
        saveLabel = renderAdditionalPromoLabelOrPrice(saveLabel, blockAddOnState.value, props.block_data);
        headerBlockPrice.value.savings = saveLabel;
        if (props.block_active) {
          updateMainProductLinePrice(headerBlockPrice.value, props.block_data.type);
        }
      }

      if (props.block_data.display_mode === "STARTER_KIT_V2") {
        atcBtnInrTxt.innerHTML = `${checkout_label}&nbsp; - &nbsp;<s>${formatMoneyy(headerBlockPrice.value.sale_price)}</s>&nbsp;${formatMoneyy(headerBlockPrice.value.discount_price)}`;
      }
    }

    /**
     * Returns the default block header discount can be used on block active/inactive
     * @returns {object} default block header discount array
     */
    function initBlockHeaderDiscount() {
      return props.block_data.add_ons.map((a) => {
        if (
          (a.default_purchase_type === "SUBSCRIPTION" && a.enable_discount === "SUBSCRIPTION") ||
          a.enable_discount === "BOTH"
        ) {
          return {
            id: a.id,
            discount_value: parseFloat(a.subscription_discount_value),
            discount_value_type: a.subscription_discount_value_type,
          };
        }
        if (
          (a.default_purchase_type === "ANNUAL_PREPAID" && a.enable_discount === "ANNUAL_PREPAID") ||
          a.enable_discount === "BOTH"
        ) {
          return {
            id: a.id,
            discount_value: parseFloat(a.annual_prepaid_discount_value),
            discount_value_type: a.annual_prepaid_discount_value_type,
          };
        }
        if (
          (a.default_purchase_type === "ONE_TIME" && a.enable_discount === "ONE_TIME") ||
          a.enable_discount === "BOTH"
        ) {
          return {
            id: a.id,
            discount_value: parseFloat(a.one_time_discount_value),
            discount_value_type: a.one_time_discount_value_type,
          };
        }

        return {
          id: a.id,
          discount_value: 0,
          discount_value_type: "PERCENTAGE",
        };
      });
    }

    function getTempProductSelection(addOn) {
      const firstAvailableProduct = addOn.products.find((p) => p.available);
			firstAvailableProduct.purchase_type = addOn.default_purchase_type;
			return firstAvailableProduct;
    }

    function dispatchLineItems() {
      let cartPayload = blockAddOnState.value
        .map((a) => {
          return a.data.map((p) => {
            let lineItem = {
              id: p.variant_id,
              properties: {
                _compare_at_price: p.compare_at_price ? p.compare_at_price : "0",
								_compare_at_price_discount: p.compare_at_price
									? Math.round(((p.compare_at_price - p.price) / p.compare_at_price) * 100).toString()
                  : "0",
              },
            };
            // Push gift card discount settings property
            props.block_data.add_ons.forEach((add_on) => {
              if (a.id === add_on.id && add_on.type === 'gift_add_on') {
                lineItem = {
                  ...lineItem,
                  properties: {
                    ...lineItem.properties,
                    _discount_settings: add_on.discount_settings,
                    _promotional_source: "car-diffuser-set-promo",
                  },
                };
              }
            })
            if (p.purchase_type === "SUBSCRIPTION" || p.purchase_type === "ANNUAL_PREPAID") {
              lineItem.selling_plan = parseInt(p.selling_plan_id);
              lineItem.properties._notes = "Initial Subscription Order";
            }
            return lineItem;
          });
        })
        .flat();
      let hiddenProducts = blockHiddenAddOnState.value.map((p) => {
        return {
          id: p.id,
        };
      });
      cartPayload = [...cartPayload, ...hiddenProducts];
      ctx.emit("on-line-item-dispatch", cartPayload);
    }

    function handleBlockEnable(e) {
      if (!e.target.checked) {
        ctx.emit("on-block-unselect", null);
      } else {
        ctx.emit(
          "on-block-select",
          props.block_data.id,
          props.block_data.add_to_cart_label,
          props.block_data.redirect_to_checkout,
          isOutOfStock.value
        );
      }
    }

    function handleAddOnDisabled(e) {
      blockAddOnState.value = blockAddOnState.value.map((a) => {
        if (a.id === e.id) {
          return { ...e, data: [] };
        }
        return a;
      });
    }

    function handleAddOnSelect(e) {
      //console.log(e,"addon selected");
      blockAddOnState.value = blockAddOnState.value.map((a) => {
        if (a.id === e.id) {
          return e;
        }
        return a;
      });
    }

    function handeGiftAddOn(e) {
      blockAddOnState.value = blockAddOnState.value.map((a) => {
        if (a.id === e.id) {
          return e;
        }
        return a;
      });
    }

    function handleAddOnUpdate(e) {
      blockAddOnState.value = blockAddOnState.value.map((a) => {
        if (a.id === e.id) {
          return {
            ...a,
            data: a.data.map((p) => {
              if (p.variant_id === e.variant_id) {
                return {
                  ...p,
                  purchase_type: e.purchase_type,
                };
              }
              return p;
            }),
          };
        }
        return a;
      });
    }

    return {
      doesSubAdnExist,
      blockAddOnState,
      blockHiddenAddOnState,
      headerBlockPrice,
      discountForMainProductFrmAdnArr,
      annualPrepaidInfo,
      morePerksBtnElRef,
      handleBlockEnable,
      formatMoneyy,
      calculateDiscountedPrice,
      handleAddOnDisabled,
      handleAddOnSelect,
      handleAddOnUpdate,
      handeGiftAddOn,
    };
  },
  delimiters: ["${", "}"],
});

paymentOptionsApp.component("pb-multi-addon-block", {
  template: "#pbMultiAddonBlock",
  emits: ["on-block-select", "on-lead-form-active", "on-block-unselect"],
  props: ["block_data", "block_active", "is_preselected", "payment_options_data", "input_type"],
  setup(props, ctx) {
    const doesSubAdnExist = ref(false);
    const blockAddOnState = ref(
      props.block_data.add_ons
        .filter((a) => !a.hidden)
        .map((a) => {
          return {
            id: a.id,
            data: [],
          };
        })
    );
    const headerBlockPrice = ref({
      sale_price: 0,
      discount_price: 0,
      savings: [],
    });
    const discountForMainProductFrmAdnArr = ref(initBlockHeaderDiscount());
    const annualPrepaidInfo = ref({});
    const isSubmitting = ref(false);
    const isValid = ref(false);
    const isSoldOut = ref(false);
    const currentMainProductVarId = ref(null);
    const errMsg = ref('');
    const quantity = ref(1);
    let variantInputEl = null;

    watch(() => props.block_active, () => {
        if (!props.block_active) {
          doesSubAdnExist.value = false;
          blockAddOnState.value = blockAddOnState.value.map((a) => ({
            ...a,
            data: [],
          }));
        } else {
          discountForMainProductFrmAdnArr.value = initBlockHeaderDiscount();
          updateBlockHeaderPriceInfo();
        }
    });

    watch(blockAddOnState, () => {
      isValid.value = blockAddOnState.value[0]?.data?.length === props.block_data.max_limit;
      if (blockAddOnState.value[0]?.data?.length) {
        doesSubAdnExist.value = blockAddOnState.value[0]?.data.some(p => p.purchase_type === 'SUBSCRIPTION');
      }

      discountForMainProductFrmAdnArr.value = discountForMainProductFrmAdnArr.value.map((d) => {
          let activeAdn = blockAddOnState.value.find((b) => b.id === d.id);
          if (
            activeAdn.data.length &&
            activeAdn.data[0].purchase_type === "SUBSCRIPTION" &&
            (activeAdn.data[0]?.enable_discount === "SUBSCRIPTION" || activeAdn.data[0]?.enable_discount === "BOTH")
          ) {
            return {
              id: d.id,
              discount_value: parseFloat(activeAdn.data[0].subscription_discount_value),
              discount_value_type: activeAdn.data[0].subscription_discount_value_type,
            };
          }
          if (
            activeAdn.data.length &&
            activeAdn.data[0].purchase_type === "ONE_TIME" &&
            (activeAdn.data[0]?.enable_discount === "ONE_TIME" || activeAdn.data[0]?.enable_discount === "BOTH")
          ) {
            return {
              id: d.id,
              discount_value: parseFloat(activeAdn.data[0].one_time_discount_value),
						  discount_value_type: activeAdn.data[0].one_time_discount_value_type,
            };
          }
          //console.log(activeAdn.data.length,activeAdn.data[0].purchase_type,activeAdn.data[0]?.enable_discount,"annual prepaid if conditions");
          if (
            activeAdn.data.length &&
            activeAdn.data[0].purchase_type === "ANNUAL_PREPAID" &&
            activeAdn.data[0]?.enable_discount === "ANNUAL_PREPAID"
          ) {
            //console.log("annual prepaid");
            return {
              id: d.id,
              discount_value: parseFloat(activeAdn.data[0].annual_prepaid_discount_value),
						  discount_value_type: activeAdn.data[0].annual_prepaid_discount_value_type,
            };
          }
          return {
            id: d.id,
            discount_value: 0,
            discount_value_type: "PERCENTAGE",
          };
        });
        if (blockAddOnState.value[0]?.data?.length === 0) {
          discountForMainProductFrmAdnArr.value = initBlockHeaderDiscount();
        }
      updateBlockHeaderPriceInfo();
    });

    function handleBlockEnable(e) {
      if (!e.target.checked) {
        ctx.emit("on-block-unselect", null);
      } else {
        ctx.emit("on-block-select", props.block_data.id, "", "", null);
      }
    }

    function variantChangedHandler(e) {
      console.log("🚀 ~ variantChangedHandler ~ e:", e);
      if (props.block_active) {
        updateBlockHeaderPriceInfo();
      }
      variantInputEl = document.querySelector(".form input[name='id']");
      currentMainProductVarId.value = variantInputEl ? variantInputEl.value : null;
      if (currentMainProductVarId.value) {
				let selectedVariant = props.block_data.parent_product.variants.find(v => v.id == currentMainProductVarId.value);
				isSoldOut.value = !selectedVariant.available;
			}
    }

    onMounted(() => {
      variantInputEl = document.querySelector(".form input[name='id']");
      currentMainProductVarId.value = variantInputEl ? variantInputEl.value : null;
      document.addEventListener(productInfoSectionId, variantChangedHandler);
      if (props.is_preselected) {
        ctx.emit("on-block-select", props.block_data.id, "", "", null);
      }
    });

    onUnmounted(() => {
      document.removeEventListener(productInfoSectionId, variantChangedHandler);
    });

    function updateBlockHeaderPriceInfo() {
			const overidePrice = parseFloat(props.block_data.original_price) * 100 || 0;
			const overideSalePriceDiscount = parseFloat(props.block_data.sale_price) || 0;
			const priceRenderMode = props.block_data.price_render_mode;
			// getting top line price from global context.
			let salePrice = parseFloat(window.mainProductPrice.sale_price) || 0;
			let discountPrice = window.mainProductPrice.discount_price
				? parseFloat(window.mainProductPrice.discount_price)
				: null;
			let saveLabel = [formatSavingsLabel(window.mainProductPrice.savings)];
			// overide product price
			if (overidePrice) {
				salePrice = overidePrice;
			}
			if (overideSalePriceDiscount) {
				discountPrice = calculateDiscountedPrice(salePrice, overideSalePriceDiscount);
				saveLabel = [formatSavingsLabel(overideSalePriceDiscount)];
				//console.log(discountPrice,overideSalePriceDiscount,saveLabel,"discount from pay in full overide");
			}
			// console.log(discountForMainProductFrmAdnArr.value, "discountForMainProductFrmAdnArr.value");
			let addOnTotalDiscount = calculateTotalAdnDiscount(discountForMainProductFrmAdnArr.value, salePrice);
			//console.log(addOnTotalDiscount,"addon total discount");
			discountPrice = calculateDiscountedPrice(salePrice, addOnTotalDiscount);
			if (addOnTotalDiscount) saveLabel = [formatSavingsLabel(addOnTotalDiscount)];
			//console.log(addOnTotalDiscount,discountPrice,saveLabel,"add on total discount and price");
			// if there is no addon discount fallback to default discount
			if (!addOnTotalDiscount) {
				discountPrice = window.mainProductPrice.discount_price
					? parseFloat(window.mainProductPrice.discount_price)
					: null;
				if (overideSalePriceDiscount) {
					discountPrice = calculateDiscountedPrice(salePrice, overideSalePriceDiscount);
					saveLabel = [formatSavingsLabel(overideSalePriceDiscount)];
				}
				//console.log(discountPrice,overideSalePriceDiscount,saveLabel,"inside if there is no discount fallback");
			}

			// check if combined price is enabled if true then add the oil price with the main product price.
			if (priceRenderMode === "DISPLAY_COMBINED_PRICE") {
				// format the existing product label according to combined price.
				if (addOnTotalDiscount) {
					saveLabel = [`${addOnTotalDiscount.toFixed(2)}% OFF ${props.block_data.parent_product.title}`];
				} else {
					saveLabel = [`${window?.mainProductPrice?.savings} OFF ${props.block_data.parent_product.title}`];
				}

				let { totalSalePrice, totalDiscountPrice } = getTotalAddonPrice(blockAddOnState.value, "multiple");
				if (!totalSalePrice && !totalDiscountPrice) {
					const tempAddOnState = props.block_data.add_ons
						.filter((a) => !a.hidden)
						.map((a) => {
							const tempProduct = getTempProductSelection(a);
							return {
								id: a.id,
								data: [tempProduct],
							};
						});
					({ totalSalePrice, totalDiscountPrice } = getTotalAddonPrice(tempAddOnState));
				}

				salePrice = salePrice + totalSalePrice;
				//console.log(discountPrice, totalDiscountPrice, totalSalePrice, "discount", "addon discount", "total sale price");
				if (discountPrice != null && totalDiscountPrice) {
					discountPrice = discountPrice + totalDiscountPrice;
				} else if (!discountPrice && totalDiscountPrice) {
					discountPrice = Math.abs(salePrice - totalDiscountPrice);
				} else if (discountPrice != null && !totalDiscountPrice) {
					discountPrice = discountPrice + totalSalePrice;
				}

				headerBlockPrice.value.sale_price = salePrice;
				headerBlockPrice.value.discount_price = discountPrice;
				// updating label from addons when combined price is enabled.
				saveLabel = getSavingsLabelForAddons(saveLabel, blockAddOnState.value);
				saveLabel = renderAdditionalPromoLabelOrPrice(saveLabel, blockAddOnState.value, props.block_data);
				headerBlockPrice.value.savings = saveLabel;
				if (props.block_active) {
					updateMainProductLinePrice(headerBlockPrice.value, props.block_data.type);
				}
			} else if (priceRenderMode === "DISPLAY_COMBINED_PRICE_W_DISCOUNT") {
				let totalCombinedDiscount = null;
				saveLabel = [];
				let { totalSalePrice, totalDiscountPrice } = getTotalAddonPrice(blockAddOnState.value, "multiple");
				if (!totalSalePrice && !totalDiscountPrice) {
					const tempAddOnState = props.block_data.add_ons
						.filter((a) => !a.hidden)
						.map((a) => {
							const tempProduct = getTempProductSelection(a);
							return {
								id: a.id,
								data: [tempProduct],
							};
						});
					({ totalSalePrice, totalDiscountPrice } = getTotalAddonPrice(tempAddOnState));
					totalSalePrice = totalSalePrice * 3;
					if (totalDiscountPrice) {
						totalDiscountPrice = totalDiscountPrice * 3;
					}
				}
				salePrice = salePrice + totalSalePrice;
				//console.log(discountPrice, totalDiscountPrice, totalSalePrice, "discount", "addon discount", "total sale price");
				if (discountPrice != null && totalDiscountPrice) {
					discountPrice = discountPrice + totalDiscountPrice;
				} else if (!discountPrice && totalDiscountPrice) {
					discountPrice = Math.abs(salePrice - (totalSalePrice - totalDiscountPrice));
				} else if (discountPrice != null && !totalDiscountPrice) {
					discountPrice = discountPrice + totalSalePrice;
				}

				headerBlockPrice.value.sale_price = salePrice;
				headerBlockPrice.value.discount_price = discountPrice;
				totalCombinedDiscount = calculateDiscountPercentage(salePrice, discountPrice);
				// updating label from addons when combined price is enabled.
				if (totalCombinedDiscount) {
					saveLabel = [`${formatSavingsLabel(totalCombinedDiscount)}`];
					saveLabel = renderAdditionalPromoLabelOrPrice(saveLabel, blockAddOnState.value, props.block_data);
				}

				headerBlockPrice.value.savings = saveLabel;
				if (props.block_active) {
					updateMainProductLinePrice(headerBlockPrice.value, props.block_data.type);
				}
			} else if (priceRenderMode === "DISPLAY_ADD_ON_PRICE") {
				let { totalSalePrice, totalDiscountPrice } = getTotalAddonPrice(blockAddOnState.value);
				if (!totalSalePrice && !totalDiscountPrice) {
					const tempAddOnState = props.block_data.add_ons
						.filter((a) => !a.hidden)
						.map((a) => {
							const tempProduct = getTempProductSelection(a);
							return {
								id: a.id,
								data: [tempProduct],
							};
						});
					({ totalSalePrice, totalDiscountPrice } = getTotalAddonPrice(tempAddOnState));
				}
				headerBlockPrice.value.sale_price = totalSalePrice;
				headerBlockPrice.value.discount_price = totalDiscountPrice || null;

				//Update the main product price with discounts
				if (props.block_active) {
					updateMainProductLinePrice(
						{
							sale_price: salePrice,
							discount_price: discountPrice,
							savings: renderAdditionalPromoLabelOrPrice(saveLabel, blockAddOnState.value, props.block_data),
						},
						props.block_data.type
					);
				}
			} else if (priceRenderMode === "DISPLAY_MAIN_PRODUCT_PRICE") {
				headerBlockPrice.value.sale_price = salePrice;
				headerBlockPrice.value.discount_price = discountPrice;
				saveLabel = renderAdditionalPromoLabelOrPrice(saveLabel, blockAddOnState.value, props.block_data);
				headerBlockPrice.value.savings = saveLabel;
				if (props.block_active) {
					updateMainProductLinePrice(headerBlockPrice.value, props.block_data.type);
				}
			}
		}

    function getTempProductSelection(addOn) {
      const firstAvailableProduct = addOn.products.find((p) => p.available);
      firstAvailableProduct.purchase_type = addOn.default_purchase_type;
      return firstAvailableProduct;
    }

    /**
     * Returns the default block header discount can be used on block active/inactive
     * @returns {object} default block header discount array
     */
    function initBlockHeaderDiscount() {
      return props.block_data.add_ons.map((a) => {
        if (
          (a.default_purchase_type === "SUBSCRIPTION" && a.enable_discount === "SUBSCRIPTION") ||
          a.enable_discount === "BOTH"
        ) {
          return {
            id: a.id,
            discount_value: parseFloat(a.subscription_discount_value),
            discount_value_type: a.subscription_discount_value_type,
          };
        }
        if (
          (a.default_purchase_type === "ANNUAL_PREPAID" && a.enable_discount === "ANNUAL_PREPAID") ||
          a.enable_discount === "BOTH"
        ) {
          return {
            id: a.id,
            discount_value: parseFloat(a.annual_prepaid_discount_value),
            discount_value_type: a.annual_prepaid_discount_value_type,
          };
        }
        if (
          (a.default_purchase_type === "ONE_TIME" && a.enable_discount === "ONE_TIME") ||
          a.enable_discount === "BOTH"
        ) {
          return {
            id: a.id,
            discount_value: parseFloat(a.one_time_discount_value),
            discount_value_type: a.one_time_discount_value_type,
          };
        }

        return {
          id: a.id,
          discount_value: 0,
          discount_value_type: "PERCENTAGE",
        };
      });
    }

    function handleAddOnDisabled(e) {
      blockAddOnState.value = blockAddOnState.value.map((a) => {
        if (a.id === e.id) {
          return { ...e, data: [] };
        }
        return a;
      });
    }

    function handleAddOnSelect(e) {
      blockAddOnState.value = blockAddOnState.value.map((a) => {
        if (a.id === e.id) {
          return e;
        }
        return a;
      });
    }

    function handleAddOnUpdate(e) {
      blockAddOnState.value = blockAddOnState.value.map((a) => {
        if (a.id === e.id) {
          return {
            ...a,
            data: a.data.map((p) => {
              if (p.variant_id === e.variant_id) {
                return {
                  ...p,
                  purchase_type: e.purchase_type,
                };
              }
              return p;
            }),
          };
        }
        return a;
      });
    }

    async function handleAddToCart() {
      const compare_at_price_property = document.getElementById("line-item-custom-property");
			const compare_at_price_percentage_property = document.getElementById("line-item-custom-property-percentage");
      const timesact_element = document.querySelector("input[data-timesact-selling-plan]");

      let urlParams = new URLSearchParams(window.location.search);
      let properties = {};
      const lineItemProperty = props.block_data?.line_item_property;
      isSubmitting.value = true;
      errMsg.value = '';
      if (lineItemProperty) {
        const uniqueId = [lineItemProperty, currentMainProductVarId.value];
        blockAddOnState.value.forEach((a) => {
        	a.data.forEach(p => {
						uniqueId.push(p.variant_id);
					});
          if (a.data.every(p => p.purchase_type === 'SUBSCRIPTION' && p?.selling_plan_id)) {
            uniqueId.push(`sub`);
          }
        });
        properties["_bundle_set"] = uniqueId.join("_");
        properties["_quarterly_bundle_id"] = Date.now().toString();
      }

      // if (props.block_data.add_on_select_mode === "multiple") {
      //   properties["_quaterly_subs_key"] = true;
      // }

      if (urlParams.get('promo_source') === 'back_to_school' && props.block_data?.parent_product.id === 8095691342018) {
        properties["_promo_source"] = 'back_to_school';
      }

      try {
        let mainProduct = {
          quantity: quantity.value,
          id: parseInt(currentMainProductVarId.value),
          properties,
        };
        if (compare_at_price_percentage_property && compare_at_price_property) {
          mainProduct.properties = {
            ...mainProduct.properties,
            _compare_at_price: compare_at_price_property.value,
            _compare_at_price_discount: compare_at_price_percentage_property.value,
          };
        }
        if(timesact_element && timesact_element.value){
          mainProduct = {...mainProduct, selling_plan: timesact_element.value , properties: {...mainProduct.properties, _timesact_preorder: true}}
        }
        let atcProducts = [];
        blockAddOnState.value.forEach(a => {
					a.data.forEach(p => {
            const sellingPlanId = p.purchase_type === 'SUBSCRIPTION' && p?.selling_plan_id ? p?.selling_plan_id : null;
						const existingProduct = atcProducts.find(item => item.id === p.variant_id && item.selling_plan === sellingPlanId);

            if (existingProduct) {
              existingProduct.quantity += quantity.value;
              existingProduct.properties._bundle_qty = existingProduct.quantity;
            } else {
              // atcProducts.push({
              //   id: p.variant_id,
              //   quantity: 1,
              //   selling_plan: sellingPlanId,
              //   properties: {
              //     ...properties,
              //     _bundle_qty: 1,
              //   },
              // });
              let prod = {
                id: p.variant_id,
                quantity: quantity.value,
                selling_plan: sellingPlanId,
                properties: {
                  ...properties,
                  _bundle_qty: quantity.value,
                  _notes: "Initial Subscription Order",
                  _compare_at_price: p.compare_at_price ? p.compare_at_price : "0",
                  _compare_at_price_discount: p.compare_at_price
										? Math.round(((p.compare_at_price - p.price) / p.compare_at_price) * 100).toString()
                    : "0",
                }
              };
              if (props.block_data.add_on_select_mode === 'multiple') {
                prod.properties["_quaterly_subs_key"] = "true";
              }
              atcProducts.push(prod);
            }
          });
        });
        const widget = window.Rebuy.widgets.find(
          (widget) => widget.id === "52434" || widget.id === "201848"
        );
        if (widget) {
          const oilInCart = Rebuy.Cart.cart.items.find(item => item.product_type === 'Oil');
          if (atcProducts.length || oilInCart) {
            widget.detachWidget();
          }
        }
        if (props.block_data?.redirect_to_checkout) Rebuy.SmartCart.skip_open = true;
        const response = await fetch(window.Shopify.routes.root + "cart/add.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ items: [mainProduct, ...atcProducts] }),
          });
        const data = await response.json();
        if (response.status !== 200) {
          if (data.message) {
            return errMsg.value = data.message;
          }
          throw new Error("Oops! Something went wrong while adding products to the cart.");
        }
        if (data && props.block_data?.redirect_to_checkout) {
          let str = window.location.href.includes("/es/") ? "?locale=es" : "";
          str = "/checkout" + str;
          window.location.href = str;
        }
      } catch (error) {
        console.log(error, "cart error");
        errMsg.value = "Oops! Something went wrong while adding products to the cart.";
      } finally {
        isSubmitting.value = false;
      }
    }

    return {
      handleBlockEnable,
      handleAddOnDisabled,
      handleAddOnUpdate,
      handleAddOnSelect,
      handleAddToCart,
      doesSubAdnExist,
      blockAddOnState,
      headerBlockPrice,
      currentMainProductVarId,
      discountForMainProductFrmAdnArr,
      isValid,
      isSubmitting,
      isSoldOut,
      errMsg,
      quantity
    };
  },
  delimiters: ["${", "}"],
});

paymentOptionsApp.component("pb-lead-form", {
  template: "#leadFormBlock",
  emits: ["on-block-select", "on-lead-form-active", "on-block-unselect"],
  props: ["block_data", "block_active", "is_preselected", "input_type"],
  setup(props, ctx) {
    let cbPayload = {
      quantity: 1,
      id: props.block_data.affiliate_product?.id || 0,
    };

    async function callbackFlow() {
      try {
        //console.log("called from outside of scope");
        if (props.block_data.callback_flow === "GO_TO_CHECKOUT") Rebuy.SmartCart.skip_open = true;
        if (props.block_data.submission_flow === "SUBMISSION_W_MAIN_PRODUCT") {
          cbPayload.id = parseInt(document.querySelector(".form input[name='id']").value);
        }
        await handleCbATC();
        if (props.block_data.callback_flow === "GO_TO_CHECKOUT") {
          let str = window.location.href.includes("/es/") ? "?locale=es" : "";
          str = "/checkout" + str;
          window.location.href = str;
        }
      } catch (error) {
        console.log(error, "Error while adding to cart");
      } finally {
        return 1;
      }
    }

    onMounted(() => {
      if (props.block_data.payment_url && props.block_data.payment_url != "") {
        window.dynamicFormPaymentUrlOverride = props.block_data.payment_url;
      }

      if (
        props.block_data.submission_flow === "SUBMISSION_W_MAIN_PRODUCT" ||
        props.block_data.submission_flow === "SUBMISSION_W_DUPLICATE_PRODUCT"
      ) {
        if (
          props.block_data.submission_flow === "SUBMISSION_W_DUPLICATE_PRODUCT" &&
          !props.block_data.affiliate_product
        ) {
          throw new Error(
            "Duplicate Affiliate product is not set bu the submission flow set to SUBMISSION_W_DUPLICATE_PRODUCT"
          );
        }
        window.submissionCallBack = callbackFlow;
      }

      if (props.is_preselected) {
        //console.log(props.is_preselected,"preselected");
        ctx.emit("on-block-select", props.block_data.id, "", "", null);
      }

      document.addEventListener(productInfoSectionId, variantChangedHandler);

      if (props.block_data.stripe_onboarding) {
        window.stripePriceVariantId = props.block_data.stripe_onboarding;
      }
      // hot fix for large diffuser lead form issue will be removed once the rebuy issue is sorted
			// $('#formsubmit').click(() => { Rebuy.SmartCart.destroy(); });
    });

    function variantChangedHandler() {
      if (props.block_active) {
        handleMainProductPriceUpdate();
      }
    }

    onUnmounted(() => {
      document.removeEventListener(productInfoSectionId, variantChangedHandler);
    });

    function handleBlockEnable(e) {
      if (!e.target.checked) {
        ctx.emit("on-block-unselect", null);
      } else {
        ctx.emit("on-block-select", props.block_data.id, "", "", null);
      }
    }

    watch(
      () => props.block_active,
      () => {
        const defaultAddToCartBtn = document.querySelector(".AddToCart");
        if (props.block_active) {
          ctx.emit("on-lead-form-active", false);
          // update the discount price in the top line.
          defaultAddToCartBtn.style.display = "none";
          handleMainProductPriceUpdate();
        } else {
          defaultAddToCartBtn.style.display = "block";
        }
      }
    );

    function handleMainProductPriceUpdate() {
      const overideDiscount = parseFloat(props.block_data?.main_product_price_discount_overide) || 0;
      const salePrice = parseFloat(window.mainProductPrice.sale_price) || 0;
      let discountPrice = parseFloat(window.mainProductPrice.discount_price) || 0;
      let saveLabel = [formatSavingsLabel(window.mainProductPrice.savings)];
      if (overideDiscount) {
        discountPrice = calculateDiscountedPrice(salePrice, overideDiscount);
        saveLabel = [formatSavingsLabel(overideDiscount)];
      }
      updateMainProductLinePrice(
        {
          sale_price: salePrice,
          discount_price: discountPrice,
          savings: saveLabel,
        },
        props.block_data.type
      );
    }

    async function handleCbATC() {
      await fetch(window.Shopify.routes.root + "cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ items: [cbPayload] }),
      }).then((resp) => resp.json());
    }

    return {
      handleBlockEnable,
      formatMoneyy,
      calculateDiscountedPrice,
    };
  },
  delimiters: ["${", "}"],
});

paymentOptionsApp.component("gift-add-on-block", {
  template: "#giftAddonBlock",
  emits: ["on-gift-addon"],
  props: ["add_on", "force_hidden"],
  setup(props, ctx) {
    const isSelected = ref(false);
    const selectedProduct = ref();
    const isAddOnEnabled = ref(false);
    const isHidden = ref(props.add_on?.ui_hidden || props.force_hidden || false);

    onBeforeMount(() => {
      selectedProduct.value = props.add_on.product;
      if (selectedProduct.value) {
        isAddOnEnabled.value = true;
        ctx.emit("on-gift-addon", {
          id: props.add_on.id,
          data: [{ variant_id: selectedProduct.value.id }],
        });
      }
    });

    return {
      selectedProduct,
      isHidden,
      imgUrl,
    };
  },
  delimiters: ["${", "}"],
});

paymentOptionsApp.component("add-on-block", {
  template: "#add-on-block",
	emits: ["on-addon-select", "on-addon-update", "on-addon-disabled", "on-set-update", "on-submit"],
	props: ["add_on", "index", "block_data", "payment_options_data", "selected_product_oil", "select_mode", "min_limit", "max_limit"],
  setup(props, ctx) {
    const isSelected = ref(false);
    const selectedProduct = ref([]);
    const dropdownOpen = ref(false);
    const popupOpen = ref(false);
    const isAddOnEnabled = ref(false);
    const filterOptions = ref(props.add_on.product_sets);
    const selectedFilter = ref("*");
    const scentProfileOptions = ref([]);
    const filteredProductArr = ref(props.add_on.products);
    const searchString = ref("");
    const addonDropdownEl = ref(null);
    const addonPopupScrollEl = ref(null);
    const mainProdPricing = ref(window.mainProductPrice);
    const dialogBoxOpen = ref(false);

    let purchaseOptions = [
      {
        type: "SUBSCRIPTION",
        label: "Monthly Subscription",
      },
      {
        type: "ANNUAL_PREPAID",
        label: "Annual Prepaid Subscription",
      },
      {
        type: "ONE_TIME",
        label: "One Time Purchase",
      },
    ];
    const activePurchaseType = ref(props.add_on.default_purchase_type);
    purchaseOptions = purchaseOptions.filter(
      (po) =>
        po.type === props.add_on.purchase_type_option ||
      (props.add_on.purchase_type_option === "BOTH" && po.type != "ANNUAL_PREPAID")
    );

    onBeforeMount(() => {
      const variantId = document.querySelector('.x-block-buy-buttons input[name="id"]')?.value;
      handleBlockDataUpdate();
      // scent profile filter options
      scentProfileOptions.value = paymentOptionsDataObj.scentProfileOptions.filter((o) => {
        return props.add_on.products.some((p) => Array.isArray(p.scent_profiles) && p.scent_profiles.some(sp => sp.id === o.id));
      });

      if (props.add_on.mandatory) {
        isAddOnEnabled.value = true;

        if (props.add_on.select_type === 'single') {
					handeVariantSelect(props.add_on.products.find((p) => p.available === true));
				}

        if (props.add_on.select_type === 'multiple') {
					const presetAddons = [];
					const limit = props.add_on?.max_limit || 1;

					for (const p of props.add_on.products) {
						if (!p.available) continue;
						presetAddons.push(p);
						if (presetAddons.length === limit) break;
					}

					if (presetAddons.length) {
						presetAddons.forEach(p => handeVariantSelect(p));
					}
				}
      }

      // preselecting the recommended addons
      if (variantId && props.add_on?.recommended_addon_mode) {
       	handlePreselectOrPinRecommendedAddons({ detail: { variant: { id: variantId } } });
         if (props.add_on.mandatory && props.add_on.select_type === 'single') {
					handeVariantSelect(filteredProductArr.value.find((p) => p.available === true));
        }
      }
      document.addEventListener(productInfoSectionId, handlePreselectOrPinRecommendedAddons);
    });

    onUnmounted(() => {
      document.removeEventListener(productInfoSectionId, handlePreselectOrPinRecommendedAddons);
    });

    watch(props.block_data, (newVal) => {
			handleBlockDataUpdate();
		});

		function handleBlockDataUpdate() {
			const selectType = props.add_on.select_type || props.block_data?.add_on_select_mode;
			const maxLimit = props.add_on?.max_limit || props.block_data?.max_limit;
			if (selectType === 'multiple' && maxLimit) {
				if (props.block_data?.parent_product.id === 8095691342018) {
					prefillOils();
				} else {
					selectedProduct.value = new Array(maxLimit).fill(null);
				}
			}
		}


    function prefillOils() {
      let urlParams = new URLSearchParams(window.location.search);
      const maxLimit = props.add_on?.max_limit || props.block_data?.max_limit;
      selectedProduct.value = new Array(maxLimit).fill(null);
      if (urlParams.get('promo_source') === 'back_to_school') {
        let prefilledOils = [43486591647938, 43529416704194, 43529774530754];
        const availableOils = props.add_on.products.filter(p => p.available && prefilledOils.includes(p.id));
        if (availableOils.length) {
          availableOils.forEach((oil, index) => {
            if (index < maxLimit) {
              selectedProduct.value[index] = oil;
              handeVariantSelect(oil);
            }
          });
        }

      }
    }

    function handlePreselectOrPinRecommendedAddons(e) {
     const selectedMainProductVariant = e?.detail?.variant?.id || null;
			const mainProductVariantList = window?.pdpProduct?.variants || [];
      if (selectedMainProductVariant && mainProductVariantList?.length) {
        const recommendedAddonId = mainProductVariantList.find((v) => v.id == selectedMainProductVariant)?.matching_addon;
				const recommendedAddonVariant = props.add_on.products.find((p) => p.available === true && p.id == recommendedAddonId);

        if (props.add_on?.recommended_addon_mode === "PRE_SELECT" && recommendedAddonVariant) {
          handeVariantSelect(recommendedAddonVariant);
        }

        if (props.add_on?.recommended_addon_mode === "PINNED_AT_TOP") {
          resetSetFilter();
          const productArr = [...filteredProductArr.value];
          const recommendedAddonIndex = productArr.findIndex(p => p.id == recommendedAddonId);
          if (recommendedAddonIndex > -1 && recommendedAddonVariant) {
            productArr.splice(recommendedAddonIndex, 1);
            productArr.unshift(recommendedAddonVariant);
            filteredProductArr.value = productArr;
          }
        }
      }
    }

    function toggleAddOnEnable() {
      isAddOnEnabled.value = !isAddOnEnabled.value;
      if (!isAddOnEnabled.value && selectedProduct.value.length) {
        ctx.emit("on-addon-disabled", { id: props.add_on.id });
        selectedProduct.value = [];
      }
      if (isAddOnEnabled.value && props.add_on.select_type === 'single') {
        handeVariantSelect(props.add_on.products[0]);
      }
    }

    function handleRemove(index) {
      if(props.block_data.type === 'steps_block' && props.add_on.addon_ui === 'POPUP') {
				openPopup();
			}
      let tempSelectedProductArr = [...selectedProduct.value];
      tempSelectedProductArr.splice(index, 1);
      tempSelectedProductArr.push(null);
      selectedProduct.value = tempSelectedProductArr;
      ctx.emit("on-addon-select", {
        id: props.add_on.id,
        data: selectedProduct.value.filter(p => p !== null).map((p) => {
            return {
              variant_id: p.id,
              purchase_type: activePurchaseType.value,
              enable_discount: props.add_on.enable_discount,
              one_time_discount_value: props.add_on.one_time_discount_value,
              one_time_discount_value_type: props.add_on.one_time_discount_value_type,
              subscription_discount_value_type: props.add_on.subscription_discount_value_type,
              subscription_discount_value: props.add_on.subscription_discount_value,
              annual_prepaid_discount_value_type: props.add_on.annual_prepaid_discount_value_type,
              annual_prepaid_discount_value: props.add_on.annual_prepaid_discount_value,
              selling_plan_id: setSellingPlanId(p),
              price_info: p.price_info,
              variant_title: p.name,
              compare_at_price: p.compare_at_price,
              price: p.price,
            }
          })
      });

      if (props.add_on?.select_type === 'multiple' && selectedProduct.value.filter(p => p !== null).length < props.add_on?.min_limit) {
				ctx.emit("on-set-update", false);
				dialogBoxOpen.value = false;
			}
    }

    function handeVariantSelect(product) {
      if (props.add_on.select_type === 'multiple') {
        let tempSelectedProductArr = selectedProduct.value;

        for (let i = 0; i < tempSelectedProductArr.length; i++) {
          const p = tempSelectedProductArr[i];
          if (p === null) {
            tempSelectedProductArr[i] = product;
            break;
          }
        }

        selectedProduct.value = tempSelectedProductArr;
        ctx.emit("on-addon-select", {
          id: props.add_on.id,
          data: selectedProduct.value.filter(p => p !== null).map((p) => {
              return {
                variant_id: p.id,
                purchase_type: activePurchaseType.value,
                enable_discount: props.add_on.enable_discount,
                one_time_discount_value: props.add_on.one_time_discount_value,
                one_time_discount_value_type: props.add_on.one_time_discount_value_type,
                subscription_discount_value_type: props.add_on.subscription_discount_value_type,
                subscription_discount_value: props.add_on.subscription_discount_value,
                annual_prepaid_discount_value_type: props.add_on.annual_prepaid_discount_value_type,
                annual_prepaid_discount_value: props.add_on.annual_prepaid_discount_value,
                selling_plan_id: setSellingPlanId(p),
                price_info: p.price_info,
                variant_title: p.name,
                compare_at_price: p.compare_at_price,
                price: p.price,
              }
            })
        });

        if (props.add_on?.min_limit === selectedProduct.value.filter(p => p !== null).length) {
					ctx.emit("on-set-update", true);
					dialogBoxOpen.value = true;
				}
      } else {
        isAddOnEnabled.value = true;
        selectedProduct.value = [product];
        if (props.add_on.purchase_type_option != "BOTH") {
          if (
            selectedProduct.value[0]?.selling_plan_allocations.length > 0 &&
            props.add_on.purchase_type_option === "SUBSCRIPTION"
          ) {
            activePurchaseType.value = props.add_on.purchase_type_option;
          } else if (props.add_on.purchase_type_option === "ANNUAL_PREPAID") {
            activePurchaseType.value = props.add_on.purchase_type_option;
          } else {
            activePurchaseType.value = "ONE_TIME";
          }
        } else {
          if (
            props.add_on.default_purchase_type === "SUBSCRIPTION" &&
            selectedProduct.value[0]?.selling_plan_allocations.length > 0
          ) {
            activePurchaseType.value = props.add_on.default_purchase_type;
          } else if (props.add_on.default_purchase_type === "ANNUAL_PREPAID") {
            activePurchaseType.value = props.add_on.default_purchase_type;
          } else {
            activePurchaseType.value = "ONE_TIME";
          }
        }
        //console.log(selectedProduct.value[0].selling_plan_allocations.length, "selling plan");
        if (!isSelected.value) isSelected.value = true;
        ctx.emit("on-addon-select", {
          id: props.add_on.id,
          data: selectedProduct.value.map((p) => {
            return {
              variant_id: p.id,
              purchase_type: activePurchaseType.value,
              enable_discount: props.add_on.enable_discount,
              one_time_discount_value: props.add_on.one_time_discount_value,
              one_time_discount_value_type: props.add_on.one_time_discount_value_type,
							subscription_discount_value_type: props.add_on.subscription_discount_value_type,
							subscription_discount_value: props.add_on.subscription_discount_value,
							annual_prepaid_discount_value_type: props.add_on.annual_prepaid_discount_value_type,
							annual_prepaid_discount_value: props.add_on.annual_prepaid_discount_value,
              selling_plan_id: setSellingPlanId(p),
              price_info: p.price_info,
              variant_title: p.name,
              compare_at_price: p.compare_at_price,
              price: p.price,
            };
          }),
        });
        dropdownOpen.value = false;
        ctx.emit("on-set-update", true);
      }
    }

    function setSellingPlanId(variant) {
      if (activePurchaseType.value === "SUBSCRIPTION" || activePurchaseType.value === "ONE_TIME") {
        return variant.og_selling_plan_id;
      } else if (activePurchaseType.value === "ANNUAL_PREPAID") {
        return variant.annual_selling_plan_id;
      } else {
        return null;
      }
    }

    function handleRadioCheck(product) {
      let checked = false;
      if (selectedProduct.value.length && selectedProduct.value[0].id === product.id) checked = true;
      return checked;
    }

    function toggleDropdown() {
      if (props.add_on.products.length > 1) {
        dropdownOpen.value = !dropdownOpen.value;
      }
    }

    function handlePurchasePlanSelect(type) {
      if (type === "SUBSCRIPTION" && selectedProduct.value[0].selling_plan_allocations.length > 0) {
        activePurchaseType.value = type;
      } else if (
        type === "ANNUAL_PREPAID" &&
        selectedProduct.value[0].prepaid_eligible &&
        selectedProduct.value[0].annual_selling_plan_id
      ) {
        activePurchaseType.value = type;
      } else {
        activePurchaseType.value = "ONE_TIME";
      }
      ctx.emit("on-addon-update", {
        id: props.add_on.id,
        variant_id: selectedProduct.value[0].id,
        purchase_type: activePurchaseType.value,
        selling_plan_id: setSellingPlanId(selectedProduct.value[0]),
      });
    }

    function shouldRenderPurchaseOption(type) {
      if (
        (type === "SUBSCRIPTION" || type === "ANNUAL_PREPAID") &&
        !selectedProduct.value[0].selling_plan_allocations.length
      ) {
        return false;
      }
      return true;
    }

    function renderNoResults() {
      return searchString.value == "" ? "No products found" : `No products found for '${searchString.value}'`;
    }

    function resetSearchFilter() {
      searchString.value = "";
      resetSetFilter();
    }

    function handleSearch(e) {
      //console.log(e.target.value);
      searchString.value = e.target.value;
      if (searchString.value.length > 0) {
        filteredProductArr.value = props.add_on.products.filter((p) => {
          const regex = new RegExp(searchString.value, "i");
          if (regex.test(p.name) || regex.test(p.scent_notes)) return p;
        });
      } else {
        handeFilterChange(selectedFilter.value);
      }
    }

    function resetSetFilter() {
      selectedFilter.value = "*";

      if (searchString.value.length > 0) {
				filteredProductArr.value = props.add_on.products.filter((p) => {
					const regex = new RegExp(searchString.value, "i");
					if (regex.test(p.name) || regex.test(p.scent_notes)) return p;
				});
			} else {
        filteredProductArr.value = props.add_on.products;
      }

      if (addonDropdownEl.value) {
				addonDropdownEl.value.scrollTo({
					top: 0,
				});
			}

			if (addonPopupScrollEl.value) {
				addonPopupScrollEl.value.scrollTo({
					top: 0
				});
			}
    }

    function handeFilterChange(e) {
      selectedFilter.value = e;
      filteredProductArr.value = props.add_on.products.filter((p) => p.set_id.includes(e));

      if (selectedFilter.value === "*") {
        filteredProductArr.value = props.add_on.products;
      }

      if (searchString.value.length > 0) {
        filteredProductArr.value = filteredProductArr.value.filter((p) => {
          const regex = new RegExp(searchString.value, "i");
          if (regex.test(p.name)) return p;
        });
      }

     if (addonDropdownEl.value) {
				addonDropdownEl.value.scrollTo({
					top: 0,
				});
			}

      if (addonPopupScrollEl.value) {
				addonPopupScrollEl.value.scrollTo({
					top: 0
				});
			}
    }

    function handleChecked(id) {
      return id === selectedFilter.value;
    }

    function removeDecimal(value) {
      return parseInt(value);
    }

    function getOrdinal(n) {
      const suffixes = ['th', 'st', 'nd', 'rd'];
      const v = n % 100;
      return n + (suffixes[(v - 20) % 10] || suffixes[v] || suffixes[0]);
    }

    function openPopup() {
			popupOpen.value = true;
      document.body.classList.add('addon-pop__active');
		}

		function closePopup() {
			popupOpen.value = false;
			document.body.classList.remove('addon-pop__active');
		}

		function emitAddToCart() {
			closePopup();
			ctx.emit('on-submit', true);
    }

    function handleScentProfileChecked(id) { 
      return id === selectedFilter.value;
    }
    
    function handleScentProfileFilterChange(e) {
      selectedFilter.value = e;
      filteredProductArr.value = props.add_on.products.filter((p) => {
        return Array.isArray(p.scent_profiles) && p.scent_profiles.some(sp => sp.id === e);
      });

      if (selectedFilter.value === "*") {
        filteredProductArr.value = props.add_on.products;
      }

      if (searchString.value.length > 0) {
        filteredProductArr.value = filteredProductArr.value.filter((p) => {
          const regex = new RegExp(searchString.value, "i");
          if (regex.test(p.name)) return p;
        });
      }


      if (addonPopupScrollEl.value) {
        addonPopupScrollEl.value.scrollTo({
          top: 0
        });
      }
    }

    return {
      imgUrl,
      formatMoneyy,
      handeVariantSelect,
      toggleDropdown,
      handleRadioCheck,
      calculateDiscountedPrice,
      handlePurchasePlanSelect,
      toggleAddOnEnable,
      generatePaymentOptionLabels,
      shouldRenderPurchaseOption,
      handleSearch,
      resetSearchFilter,
      renderNoResults,
      handleChecked,
      handeFilterChange,
      resetSetFilter,
      removeDecimal,
      handleRemove,
      getOrdinal,
			openPopup,
			closePopup,
      emitAddToCart,
      handleScentProfileFilterChange,
      handleScentProfileChecked,
      isSelected,
      addonDropdownEl,
      filterOptions,
      filteredProductArr,
      selectedProduct,
      dropdownOpen,
      selectedFilter,
      searchString,
      purchaseOptions,
      isAddOnEnabled,
      activePurchaseType,
      mainProdPricing,
      popupOpen,
      dialogBoxOpen,
      scentProfileOptions
    };
  },
  delimiters: ["${", "}"],
});

paymentOptionsApp.component("subscription-benefit-block", {
  template: "#subscription-benefit-block",
  props: ["subs_benefit", "is_annual_plan", "subs_benefit_render_mode", "block_data"],
	setup(props) {
		return {
			generatePaymentOptionLabels
		}
	},
  delimiters: ["${", "}"],
});

paymentOptionsApp.component("build-a-plan", {
  template: "#buildAPlanBlock",
  emits: ["on-block-select", "on-lead-form-active", "on-block-unselect"],
  props: ["block_data", "block_active", "is_preselected", "input_type"],
  setup(props, ctx) {
    watch(
      () => props.block_active,
      () => {
        if (props.block_active) {
          handleMainProductPriceUpdate();
        }
      }
    );

    onMounted(() => {
      if (props.is_preselected) {
        //console.log(props.is_preselected,"preselected");
        handleBlockEnable();
      }
      document.addEventListener(productInfoSectionId, variantChangedHandler);
    });

    function variantChangedHandler() {
      if (props.block_active) handleMainProductPriceUpdate();
    }

    onUnmounted(() => {
      document.removeEventListener(productInfoSectionId, variantChangedHandler);
    });

    function handleMainProductPriceUpdate() {
      const overideDiscount = parseFloat(props.block_data?.main_product_price_discount_overide) || 0;
      const salePrice = parseFloat(window.mainProductPrice.sale_price) || 0;
      let discountPrice = parseFloat(window.mainProductPrice.discount_price) || 0;
      let saveLabel = [formatSavingsLabel(window.mainProductPrice.savings)];
      if (overideDiscount) {
        discountPrice = calculateDiscountedPrice(salePrice, overideDiscount);
        saveLabel = [formatSavingsLabel(overideDiscount)];
      }
      updateMainProductLinePrice(
        {
          sale_price: salePrice,
          discount_price: discountPrice,
          savings: saveLabel,
        },
        props.block_data.type
      );
    }

    function handleBlockEnable(e) {
      if (!e.target.checked) {
        ctx.emit("on-block-unselect", null);
      } else {
        ctx.emit(
          "on-block-select",
          props.block_data.id,
          props.block_data.add_to_cart_label,
          "",
          null,
          props.block_data.landing_page
        );
      }
    }

    return {
      handleBlockEnable,
    };
  },
  delimiters: ["${", "}"],
});

paymentOptionsApp.component('override-add-to-cart', {
  template: "#pbOverrideATCBlock",
  emits: [],
  props: ["block_data", "payment_options_data"],
  setup(props, ctx) {

    const selectedMainProdVariant = ref(null);
    const isSubmitting = ref(false);
    const isSticky = ref(false)
    const stickyBtn = ref(null)

    onBeforeMount(() => {
      document.querySelector(".AddToCart").style.display = "none";
      // document?.querySelector(".StickyAddToCart").style.display = "none";
      const selectedFirstAvailableVariant = document.querySelector('product-payment-terms form input[name="id"]')?.value;
      if (selectedFirstAvailableVariant) {
      	selectedMainProdVariant.value = getSelectedVariantDetail(selectedFirstAvailableVariant);
      }
      document.addEventListener(productInfoSectionId, variantChangedHandler);
    })

    onMounted(() => {
      window.addEventListener('scroll', handleScroll)
    })
    
    onUnmounted(() => {
      window.removeEventListener('scroll', handleScroll)
    })

    function getSelectedVariantDetail(variantId) {
      const variant = props.payment_options_data.main_product.variants.find(variant => variant.id === +variantId);
      return variant;
    }

    function variantChangedHandler(e) {
      if (e?.detail?.variant) {
        selectedMainProdVariant.value = e?.detail?.variant;
      }
    }

    async function handleATC() {
      const compare_at_price_property = document.getElementById("line-item-custom-property");
			const compare_at_price_percentage_property = document.getElementById("line-item-custom-property-percentage");
      isSubmitting.value = true;

      let mainProduct = {
        quantity: 1,
        id: parseInt(selectedMainProdVariant.value.id),
        properties: {
          _compare_at_price: compare_at_price_property.value,
          _compare_at_price_discount: compare_at_price_percentage_property.value,
        }
      };

      const response = await fetch(window.Shopify.routes.root + "cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ items: [mainProduct] }),
      });
      const data = await response.json();

      if (data) {
        isSubmitting.value = false;
      }
    }

    const handleScroll = () => {
      if (window.innerWidth >= 769) {
        isSticky.value = false;
        return;
      }
      const scrollTop = window.scrollY;
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;

      // 25% of the page scrolled
      if (scrollTop >= (documentHeight - windowHeight) * 0.25) {
        isSticky.value = true;
      } else {
        isSticky.value = false;
      }
    };

    return {
      selectedMainProdVariant,
      isSubmitting,
      isSticky,
      stickyBtn,
      handleATC,
      formatMoneyy
    };
  },
  delimiters: ["${", "}"],
});

paymentOptionsApp.component("steps-block", {
	template: "#steps-block",
	emits: ["on-block-select", "on-block-unselect"],
	props: ["block_data", "block_active", "is_preselected", "payment_options_data", "input_type"],
	setup(props, ctx) {
		const selectedProductVariant = ref(null);
		const activeAddonMode = ref(null);
		const addonsATCPayload = ref([]);
		const isValid = ref(false);
		const isSubmitting = ref(false);
		const errMsg = ref('');
		const isSoldOut = ref(false);
		const discountForMainProductFrmAdnArr = ref(initBlockHeaderDiscount());
		const blockAddOnState = ref([]);
		const headerBlockPrice = ref({
			sale_price: 0,
			discount_price: 0,
			savings: [],
		});
    const isSetComplete = ref(false);
    const quantity = ref(1);

		onBeforeMount(() => {
			const urlParams = new URLSearchParams(window.location.search);
			const variantId = urlParams.get("variant");
			activeAddonMode.value = props.block_data.options[0];
			let firstAvailableProduct = null;
			if (variantId) {
				firstAvailableProduct = props.block_data.parent_product.variants.find(
					(v) => String(v.id) === variantId && v.hidden != true
				);
			}

			if (!firstAvailableProduct) {
				firstAvailableProduct = props.block_data.parent_product.variants.find((v) => v.hidden != true);
			}

			selectedProductVariant.value = firstAvailableProduct;
			// initializing block add on state
			if (activeAddonMode.value.type !== 'MAIN_PRODUCT_ONLY') {

				blockAddOnState.value = activeAddonMode.value.add_ons
					.filter((a) => !a.hidden)
					.map((a) => {
						return {
							id: a.id,
							data: [],
						};
					});

        if (props.block_active) {
          if (window.Alpine !== undefined) {
            if(typeof window.killPriceLogicVariantListener === "function") window.killPriceLogicVariantListener();
          } else {
            document.addEventListener('alpine:init', () => {
             if(typeof window.killPriceLogicVariantListener === "function") window.killPriceLogicVariantListener();
            });
          }
					discountForMainProductFrmAdnArr.value = initBlockHeaderDiscount();
					updateBlockHeaderPriceInfo();
				}
      }
      
		});

		onMounted(() => {
			if (props.is_preselected) {
        ctx.emit("on-block-select", props.block_data.id, "", "", null);
        updateMedia(selectedProductVariant.value);
			}
		});

		watch(() => props.block_active, () => {
			if (!props.block_active) {
				blockAddOnState.value = blockAddOnState.value.map((a) => ({
					...a,
					data: [],
				}));
      } else {
        
				discountForMainProductFrmAdnArr.value = initBlockHeaderDiscount();
        updateBlockHeaderPriceInfo();
			}
		});

		watch(blockAddOnState, () => {
			discountForMainProductFrmAdnArr.value = discountForMainProductFrmAdnArr.value.map((d) => {
				let activeAdn = blockAddOnState.value.find((b) => b.id === d.id);
				if (
					activeAdn.data.length &&
					activeAdn.data[0].purchase_type === "SUBSCRIPTION" &&
					(activeAdn.data[0]?.enable_discount === "SUBSCRIPTION" || activeAdn.data[0]?.enable_discount === "BOTH")
				) {
					return {
						id: d.id,
						discount_value: parseFloat(activeAdn.data[0].subscription_discount_value),
						discount_value_type: activeAdn.data[0].subscription_discount_value_type,
					};
				}
				if (
					activeAdn.data.length &&
					activeAdn.data[0].purchase_type === "ONE_TIME" &&
					(activeAdn.data[0]?.enable_discount === "ONE_TIME" || activeAdn.data[0]?.enable_discount === "BOTH")
				) {
					return {
						id: d.id,
						discount_value: parseFloat(activeAdn.data[0].one_time_discount_value),
						discount_value_type: activeAdn.data[0].one_time_discount_value_type,
					};
				}
				if (
					activeAdn.data.length &&
					activeAdn.data[0].purchase_type === "ANNUAL_PREPAID" &&
					activeAdn.data[0]?.enable_discount === "ANNUAL_PREPAID"
				) {
					return {
						id: d.id,
						discount_value: parseFloat(activeAdn.data[0].annual_prepaid_discount_value),
						discount_value_type: activeAdn.data[0].annual_prepaid_discount_value_type,
					};
				}
				return {
					id: d.id,
					discount_value: 0,
					discount_value_type: "PERCENTAGE",
				};
			});
			if (blockAddOnState.value[0]?.data?.length === 0) {
				discountForMainProductFrmAdnArr.value = initBlockHeaderDiscount();
			}
			updateBlockHeaderPriceInfo();
		});

		function handleBlockEnable(e) {
			if (!e.target.checked) {
				ctx.emit("on-block-unselect", null);
			} else {
				ctx.emit("on-block-select", props.block_data.id, "", "", null);
			}
		}

		function handleVariantChange(e) {
			selectedProductVariant.value = e;
			if (selectedProductVariant.value) {
				dispatchVariantChangedEvent(selectedProductVariant.value);
				updateVariantInURL(selectedProductVariant.value.id);
				updateMedia(selectedProductVariant.value);
				if (props.block_active) {
					updateBlockHeaderPriceInfo();
				}
				// calculateRevisedPrice();
				// handleAtcOOS();
			}
		}

    function dispatchVariantChangedEvent(variant) {
      if (window.Alpine !== undefined) {
        Alpine.store('selectedVariant', variant);
      } else {
        document.addEventListener('alpine:init', () => {
          Alpine.store('selectedVariant', variant);
        });
      }

			document.dispatchEvent(
				new CustomEvent("variant:changed", {
					bubbles: true,
					detail: { variant },
				})
			);
		}

		function updateVariantInURL(variantId) {
			const url = new URL(window.location.href);
			url.searchParams.set("variant", variantId);
			window.history.replaceState({}, "", url);
		}

    function updateMedia(variant) {
      const el = document.getElementById(`x-product-${splitSectionId}`);
      const addonMode = activeAddonMode.value;
      const variantImageMap = addonMode?.variant_image_map;
      let featuredMediaPosition = null;

      if (!el?.splide) {
        document.addEventListener(`eurus:media-gallery-ready:${splitSectionId}`, () => {
          updateMedia(variant), { once: true }
        });
        return;
      }

      if (addonMode.type === "MAIN_PRODUCT_AND_ADDON" && Array.isArray(variantImageMap)) {
        const imageMapping = variantImageMap.find(m => m?.variant_id == variant?.id);
        featuredMediaPosition = imageMapping?.image_index - 1 ?? 0;
      } else if (addonMode.type === "ADDON_ONLY" && Array.isArray(variantImageMap)) {
        featuredMediaPosition = (variantImageMap[0]?.image_index ?? 1) - 1;
      } else {
        featuredMediaPosition = variant?.featured_media?.position - 1 || 0;
      }
      
      if (featuredMediaPosition == null) return;
      el.splide.go(featuredMediaPosition);
    }

		function handleOptionChange(option) {
			activeAddonMode.value = option;
			isSetComplete.value = false;
			addonsATCPayload.value = [];

			if (activeAddonMode.value.type !== 'MAIN_PRODUCT_ONLY') {
				discountForMainProductFrmAdnArr.value = initBlockHeaderDiscount();
				blockAddOnState.value = activeAddonMode.value.add_ons
					.filter((a) => !a.hidden)
					.map((a) => {
						return {
							id: a.id,
							data: [],
						};
					});
			} else {
				// resetting addon discount when addon mode is set to "MAIN_PRODUCT_ONLY"
				discountForMainProductFrmAdnArr.value = [];
				updateBlockHeaderPriceInfo();
			}

			updateMedia(selectedProductVariant.value);
		}

		function handleAddOnSelect(e) {
			if (e?.data && e.data.length) {
				addonsATCPayload.value = e.data;
			}
			blockAddOnState.value = blockAddOnState.value.map((a) => {
				if (a.id === e.id) {
					return e;
				}
				return a;
			});
		}

		function handleAddOnUpdate(e) {
			blockAddOnState.value = blockAddOnState.value.map((a) => {
				if (a.id === e.id) {
					return {
						...a,
						data: a.data.map((p) => {
							if (p.variant_id === e.variant_id) {
								return {
									...p,
									purchase_type: e.purchase_type,
								};
							}
							return p;
						}),
					};
				}
				return a;
			});
		}

		function handleAddOnDisabled(e) {
			blockAddOnState.value = blockAddOnState.value.map((a) => {
				if (a.id === e.id) {
					return { ...e, data: [] };
				}
				return a;
			});
		}

		async function handleAddToCart() {
			const compare_at_price_property = document.getElementById("line-item-custom-property");
			const compare_at_price_percentage_property = document.getElementById("line-item-custom-property-percentage");
      const timesact_element = document.querySelector("input[data-timesact-selling-plan]");
			let properties = {};
			isSubmitting.value = true;
			errMsg.value = '';

			try {
				let mainProduct = {
					quantity: quantity.value,
					id: parseInt(selectedProductVariant.value.id),
					properties,
        };
        
				if (compare_at_price_percentage_property && compare_at_price_property) {
					mainProduct.properties = {
						...mainProduct.properties,
						_compare_at_price: compare_at_price_property.value,
						_compare_at_price_discount: compare_at_price_percentage_property.value,
					};
				}
        if(timesact_element && timesact_element.value){
          mainProduct = {...mainProduct, selling_plan: timesact_element.value , properties: {...mainProduct.properties, _timesact_preorder: true}}
        }
				let atcProducts = [];

				if (activeAddonMode.value.type !== "MAIN_PRODUCT_ONLY") {

					if (activeAddonMode.value.type !== "ADDON_ONLY") {
						const uniqueId = [props.block_data.id, selectedProductVariant.value.id];
						addonsATCPayload.value.forEach((p) => {
							uniqueId.push(p.id);
							if (p.selling_plan) {
								if (p.purchase_type === 'SUBSCRIPTION') {
									uniqueId.push(`plan_30`);
								}
								if (p.purchase_type === 'QUARTERLY') {
									uniqueId.push(`plan_90`);
								}
							}
						});
						uniqueId.push(`ts_${Date.now()}`);

						if (uniqueId.length) {
							let bundleId = uniqueId.join("_");
							properties["_bundle_id"] = bundleId;
							mainProduct.properties["_bundle_id"] = bundleId;
							if(addonsATCPayload.value.length > 1){
								mainProduct.properties["_bundle_set_message"] = props.block_data.parent_product.title + " with " + addonsATCPayload.value.length + " oils";
							}
						}
					}

					addonsATCPayload.value.forEach(addon => {
						const sellingPlanId = addon.purchase_type === 'SUBSCRIPTION' && addon?.selling_plan_id ? addon?.selling_plan_id : null;
						const existingProduct = atcProducts.find(item => item.id === addon.variant_id && item.selling_plan === sellingPlanId);
						if (existingProduct) {
							existingProduct.quantity += quantity.value;
							existingProduct.properties._bundle_qty = existingProduct.quantity;
						} else {
							atcProducts.push({
								id: addon.variant_id,
								quantity: quantity.value,
								selling_plan: sellingPlanId,
								properties: {
									...properties,
									_notes: "Initial Subscription Order",
									_compare_at_price: addon.compare_at_price ? addon.compare_at_price : "0",
									_compare_at_price_discount: addon.compare_at_price
										? Math.round(((addon.compare_at_price - addon.price) / addon.compare_at_price) * 100).toString()
										: "0",
									...(selectedProductVariant.value.name && selectedProductVariant.value.name.includes('Monet')
										? { _bundle_subs_upgrade: false }
										: {}),
								}
							});
						}
					});
				}

				const cartPayload = [];

				if (activeAddonMode.value.type === "MAIN_PRODUCT_ONLY") {
					cartPayload.push(mainProduct);
				} else if (activeAddonMode.value.type === "MAIN_PRODUCT_AND_ADDON") {
					cartPayload.push(mainProduct);
					cartPayload.push(...atcProducts);
				} else if (activeAddonMode.value.type === "ADDON_ONLY") {
					cartPayload.push(...atcProducts);
				}

				const response = await fetch(window.Shopify.routes.root + "cart/add.js", {
					method: "POST",
					headers: {
						"Content-Type": "application/json",
					},
					body: JSON.stringify({ items: cartPayload }),
				});
				const data = await response.json();

				if (response.status !== 200) {
					if (data.message) {
						return errMsg.value = data.message;
					}
					throw new Error("Oops! Something went wrong while adding products to the cart.");
				}
			} catch (error) {
				console.log(error, "error");
				errMsg.value = "Oops! Something went wrong while adding products to the cart.";
			} finally {
				isSubmitting.value = false;
			}
		}

		function initBlockHeaderDiscount() {
			if (activeAddonMode.value && activeAddonMode.value.type !== 'MAIN_PRODUCT_ONLY') {
				return activeAddonMode.value.add_ons
					.map((a) => {
						if (
							(a.default_purchase_type === "SUBSCRIPTION" && a.enable_discount === "SUBSCRIPTION") ||
							a.enable_discount === "BOTH"
						) {
							return {
								id: a.id,
								discount_value: parseFloat(a.subscription_discount_value),
								discount_value_type: a.subscription_discount_value_type,
							};
						}
						if (
							(a.default_purchase_type === "ANNUAL_PREPAID" && a.enable_discount === "ANNUAL_PREPAID") ||
							a.enable_discount === "BOTH"
						) {
							return {
								id: a.id,
								discount_value: parseFloat(a.annual_prepaid_discount_value),
								discount_value_type: a.annual_prepaid_discount_value_type,
							};
						}
						if (
							(a.default_purchase_type === "ONE_TIME" && a.enable_discount === "ONE_TIME") ||
							a.enable_discount === "BOTH"
						) {
							return {
								id: a.id,
								discount_value: parseFloat(a.one_time_discount_value),
								discount_value_type: a.one_time_discount_value_type,
							};
						}

						return {
							id: a.id,
							discount_value: 0,
							discount_value_type: "PERCENTAGE",
						};
					});
			}
			return [];
		}

		function getTempProductSelection(addOn) {
			const tempSelections = [];
			const limit = addOn?.max_limit || 1;

			for (const p of addOn.products) {
				if (!p.available) continue;
				p.purchase_type = addOn.default_purchase_type;
				tempSelections.push(p);
				if (tempSelections.length === limit) break;
			}

			if (tempSelections.length) return tempSelections;
		}

    function updateBlockHeaderPriceInfo() {
			let priceRenderMode = activeAddonMode.value?.price_render_mode || 'MAIN_PRODUCT_PRICE';
			let salePrice = parseFloat(window.mainProductPrice.sale_price) || 0;
			let discountPrice = window.mainProductPrice.discount_price ? parseFloat(window.mainProductPrice.discount_price) : null;
			let saveLabel = [formatSavingsLabel(window.mainProductPrice.savings)];
			let addOnTotalDiscount = calculateTotalAdnDiscount(discountForMainProductFrmAdnArr.value, salePrice);
			discountPrice = calculateDiscountedPrice(salePrice, addOnTotalDiscount);

			if (addOnTotalDiscount) saveLabel = [formatSavingsLabel(addOnTotalDiscount)];

			if (!addOnTotalDiscount) {
				discountPrice = window.mainProductPrice.discount_price
					? parseFloat(window.mainProductPrice.discount_price)
					: null;
			}

			if (priceRenderMode === "COMBINED_PRICE" || priceRenderMode === "PRESET_COMBINED_PRICE") {
				if (addOnTotalDiscount) {
					saveLabel = [`${addOnTotalDiscount.toFixed()}% OFF ${props.block_data.parent_product.title}`];
				} else {
					saveLabel = [`${window?.mainProductPrice?.savings} OFF ${props.block_data.parent_product.title}`];
				}

				let { totalSalePrice, totalDiscountPrice } = getTotalAddonPrice(blockAddOnState.value, "multiple");

				if (priceRenderMode === "PRESET_COMBINED_PRICE") {
					const tempAddOnState = activeAddonMode.value.add_ons
						.filter((a) => !a.hidden)
						.map((a) => {
							const tempProducts = getTempProductSelection(a);
							return {
								id: a.id,
								data: tempProducts,
							};
						});
					({ totalSalePrice, totalDiscountPrice } = getTotalAddonPrice(tempAddOnState,"multiple"));
				}

				salePrice = salePrice + totalSalePrice;
				if (discountPrice != null && totalDiscountPrice) {
					discountPrice = discountPrice + totalDiscountPrice;
				} else if (!discountPrice && totalDiscountPrice) {
					discountPrice = Math.abs(salePrice - totalDiscountPrice);
				} else if (discountPrice != null && !totalDiscountPrice) {
					discountPrice = discountPrice + totalSalePrice;
				}

				headerBlockPrice.value.sale_price = salePrice;
				headerBlockPrice.value.discount_price = discountPrice;
				// updating label from addons when combined price is enabled.
				saveLabel = getSavingsLabelForAddons(saveLabel, blockAddOnState.value);
				saveLabel = renderAdditionalPromoLabelOrPrice(saveLabel, blockAddOnState.value, activeAddonMode.value);
				headerBlockPrice.value.savings = saveLabel;

				if (props.payment_options_data.main_product.handle === 'kube-portable-scent-diffuser') {
				   blockAddOnState.value.forEach(addonGroup => {
				      // Check if this Add-on group has a selection active
				      if (addonGroup.data.length > 0) {
				         const addonId = addonGroup.id;
				         
				         if (addonId === 'adn_0_143906275522') {
				            headerBlockPrice.value.savings = ['SAVE $25'];
				         } else if (addonId === 'adn_0_143915024578') {
				            headerBlockPrice.value.savings = ['SAVE $50'];
				         }
				      }
				   });
				}

				if (props.block_active) {
					updateMainProductLinePrice(headerBlockPrice.value, props.block_data.type);
				}
			} else if (priceRenderMode === "OVERRIDE_PRICE" && activeAddonMode.value?.override_sale_price) { 
				saveLabel = [];
				salePrice = Number(activeAddonMode.value?.override_sale_price) * 100;

				if (activeAddonMode.value?.override_compare_at_price) {
					salePrice = Number(activeAddonMode.value?.override_compare_at_price) * 100;
					discountPrice = Number(activeAddonMode.value?.override_sale_price) * 100;
					saveLabel = calculateDiscountPercentage(salePrice,discountPrice);
				}

				headerBlockPrice.value.sale_price = salePrice;
				headerBlockPrice.value.discount_price = discountPrice;
				headerBlockPrice.value.savings = saveLabel;

				if (props.block_active) {
					updateMainProductLinePrice(headerBlockPrice.value, props.block_data.type);
				}
			} else if (priceRenderMode === "COMBINE_PRICE_APPLY_DISCOUNT_TO_ALL") {
				let { totalSalePrice, totalDiscountPrice } = getTotalAddonPrice(blockAddOnState.value, "multiple");
				salePrice = salePrice + totalSalePrice;
				saveLabel = [];

				if (addOnTotalDiscount) {
					discountPrice = calculateDiscountedPrice(salePrice, addOnTotalDiscount);
					saveLabel = [`SAVE ${calculateDiscountPercentage(salePrice, discountPrice).toFixed()}%`];
				}

				headerBlockPrice.value.sale_price = salePrice;
				headerBlockPrice.value.discount_price = discountPrice;
				headerBlockPrice.value.savings = saveLabel;

				if (props.block_active) {
					updateMainProductLinePrice(headerBlockPrice.value, props.block_data.type);
				}
			} else if (priceRenderMode === "MAIN_PRODUCT_PRICE" || activeAddonMode.value.type === "MAIN_PRODUCT_ONLY") {
				headerBlockPrice.value.sale_price = salePrice;
				headerBlockPrice.value.discount_price = discountPrice;
				headerBlockPrice.value.savings = saveLabel;
				if (props.block_active) {
					updateMainProductLinePrice(headerBlockPrice.value, props.block_data.type);
				}
			} else if (priceRenderMode === "ADD_ON_PRICE") {
				let { totalSalePrice, totalDiscountPrice } = getTotalAddonPrice(blockAddOnState.value, "multiple");
				if (!totalSalePrice && !totalDiscountPrice) {
					const tempAddOnState = activeAddonMode.value.add_ons
						.filter((a) => !a.hidden)
						.map((a) => {
							const tempProduct = getTempProductSelection(a);
							return {
								id: a.id,
								data: [tempProduct],
							};
						});
					({ totalSalePrice, totalDiscountPrice } = getTotalAddonPrice(tempAddOnState, "multiple"));
				}

				headerBlockPrice.value.sale_price = totalSalePrice;
				headerBlockPrice.value.discount_price = totalDiscountPrice || null;
				saveLabel = [];
				if (totalDiscountPrice) {
					saveLabel = [formatSavingsLabel(calculateDiscountPercentage(totalSalePrice, totalDiscountPrice))];
				}
				headerBlockPrice.value.savings = saveLabel;
				//Update the main product price with discounts
				if (props.block_active) {
					updateMainProductLinePrice(headerBlockPrice.value, props.block_data.type);
				}
			}
		}

		function handleSetUpdate(e) {
			isSetComplete.value = e;
		}

		function isPurchaseDisabled() {
			if (activeAddonMode.value.type === "MAIN_PRODUCT_ONLY") {
				return false;
			}

			return isSoldOut.value || !isSetComplete.value;
		}

		function handleOnSubmit() {
			handleAddToCart();
		}

		return {
			selectedProductVariant,
			activeAddonMode,
			addonsATCPayload,
			isValid,
			isSoldOut,
			isSubmitting,
			errMsg,
			discountForMainProductFrmAdnArr,
			blockAddOnState,
			headerBlockPrice,
      isSetComplete,
      quantity,
			handleBlockEnable,
			handleVariantChange,
			dispatchVariantChangedEvent,
			updateVariantInURL,
			updateMedia,
			handleOptionChange,
			handleAddOnSelect,
			handleAddOnUpdate,
			handleAddOnDisabled,
			handleAddToCart,
			initBlockHeaderDiscount,
			updateBlockHeaderPriceInfo,
			calculateDiscountedPrice,
			handleSetUpdate,
			isPurchaseDisabled,
			handleOnSubmit
		}
	},
	delimiters: ["${", "}"],
});

paymentOptionsApp.component("product-variant-select", {
	template: "#variantSelect",
	props: ["selected_product", "main_product"],
	emits: ["on_variant_change"],
	setup(props, ctx) {
		const selectedVariant = ref(null);
		const variantContEl = ref(null);
		const productObj = ref(null);

		onBeforeMount(() => {
			productObj.value = props.main_product;
		});

		onMounted(() => {
			selectedVariant.value = props.selected_product;
			if (selectedVariant.value) {
				handleVariantChecked();
				hideUnRelatedVariants();
				ctx.emit("on_variant_change", selectedVariant.value);
			}
		});

		function handleVariantChecked() {
			if (variantContEl.value) {
				selectedVariant.value.options.forEach((option_value) => {
					variantContEl.value.querySelectorAll(`input[type='radio'][value='${option_value}']`).forEach((el) => {
						el.checked = true;
					});
				});
			}
		}

		function hideUnRelatedVariants() {
			const optionWithValues = productObj.value?.options_with_values;
			const activeOptions = [...selectedVariant.value.options];
			const productVariants = productObj.value.variants;
			const swatchGroups = variantContEl.value.querySelectorAll(".variant-block__swatch");
			variantContEl.value
				.querySelectorAll(`input[type='radio']`)
				.forEach((el) => el.parentElement.classList.remove("hide-option"));
			swatchGroups.forEach((grpEl, i) => {
				let groupPosition = parseInt(grpEl.getAttribute("data-option-position"));
				if (optionWithValues.length > 1 && groupPosition > 1 && groupPosition <= optionWithValues.length) {
					const primaryOptions = activeOptions.slice(0, i);
					let groupInputs = grpEl.querySelectorAll('input[type="radio"]');
					if (groupInputs) {
						groupInputs.forEach((el) => {
							let isPartOfAnyVariant = false;
							for (let variant of productVariants) {
								const optionCombination = [...primaryOptions, el.value];
								const isUnRelatedVariant = optionCombination.every((o) => variant.options.includes(o));
								if (isUnRelatedVariant) {
									isPartOfAnyVariant = true;
									break;
								}
							}
							if (!isPartOfAnyVariant) {
								el.parentElement.classList.add("hide-option");
							}
						});
					}
				}
			});
		}

		function handleDisableVariant(option_name) {
			return selectedVariant.value.options.includes(option_name);
		}

		function handleVariantSelect(e) {
			const selectedOptionArr = [];
			const selectedVariantInputRadio = variantContEl.value.querySelectorAll("input[type='radio']:checked");
			const productVariants = productObj.value.variants;
			let matchedVariant = null;
			selectedVariantInputRadio.forEach((el) => {
				selectedOptionArr.push(el.value);
			});
			if (selectedOptionArr.length) {
				for (let variant of productVariants) {
					const isSelectedVariant = selectedOptionArr.every((o) => variant.options.includes(o));
					if (isSelectedVariant) {
						matchedVariant = variant;
						break;
					}
				}
				if (matchedVariant) {
					selectedVariant.value = matchedVariant;
				} else {
					let partialCombination = [e.target.value];
					if (selectedOptionArr.length > 2) {
						const optionsLength = productObj.value?.options_with_values.length;
						partialCombination = selectedOptionArr.slice(0, optionsLength - 1);
					}
					for (let variant of productVariants) {
						const isSelectedVariant = partialCombination.every((o) => variant.options.includes(o));
						if (isSelectedVariant) {
							matchedVariant = variant;
							break;
						}
					}
					if (!matchedVariant) {
						matchedVariant = productVariants.find((variant) => variant.options.includes(e.target.value));
					}
				}
			}
			selectedVariant.value = matchedVariant;
			handleVariantChecked();
			hideUnRelatedVariants();
			ctx.emit("on_variant_change", selectedVariant.value);
		}

		return {
			selectedVariant,
			variantContEl,
			productObj,
			handleVariantChecked,
			handleVariantSelect,
			handleize,
			handleDisableVariant,
		};
	},
	delimiters: ["${", "}"],
});


paymentOptionsApp.mount("#paymentBlocksApp");

function imgUrl(url, size) {
  if (!url) url = `https://cdn.shopify.com/shopifycloud/shopify/assets/no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c.gif`;
  // remove any current image size then add the new image size
  return url
  .replace(/_(pico|icon|thumb|small|compact|medium|large|grande|original|1024x1024|2048x2048|master)+\./g, ".")
    .replace(/\.jpg|\.png|\.gif|\.jpeg/g, function (match) {
      return "_" + size + match;
    });
}

function formatMoneyy(cents, format = "") {
  if (typeof cents === "string") {
    cents = cents.replace(".", "");
  }
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
    formatString = format || window.themeVariables.settings.moneyFormat;
  function defaultTo(value2, defaultValue) {
    return value2 == null || value2 !== value2 ? defaultValue : value2;
  }
  function formatWithDelimiterss(number, precision, thousands, decimal) {
    precision = defaultTo(precision, 2);
    thousands = defaultTo(thousands, ",");
    decimal = defaultTo(decimal, ".");

    if (isNaN(number) || number == null) {
      return 0;
    }

    let value = number / 100;
		const cents = Math.round((value % 1) * 100);

		if (cents > 0 && cents < 5) {
			value = Math.floor(value);
			precision = 0;
		}

		let formatted = value.toFixed(precision);
		let parts = formatted.split(".");
		let dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands);
		let centsAmount = parts[1] ? decimal + parts[1] : "";  

    return dollarsAmount + centsAmount;
  }
  let value = "";
  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiterss(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiterss(cents, 0);
      break;
    case "amount_with_space_separator":
      value = formatWithDelimiterss(cents, 2, " ", ".");
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiterss(cents, 2, ".", ",");
      break;
    case "amount_with_apostrophe_separator":
      value = formatWithDelimiterss(cents, 2, "'", ".");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiterss(cents, 0, ".", ",");
      break;
    case "amount_no_decimals_with_space_separator":
      value = formatWithDelimiterss(cents, 0, " ");
      break;
    case "amount_no_decimals_with_apostrophe_separator":
      value = formatWithDelimiterss(cents, 0, "'");
      break;
  }
  if (formatString.indexOf("with_comma_separator") !== -1) {
    return formatString.replace(placeholderRegex, value);
  } else {
    return formatString.replace(placeholderRegex, value);
  }
}

function roundNumber(num, savings, precision = 2) {
  if (isNaN(num)) {
    return;
  }

  let nummm = num.toFixed(3).split(".")[1].slice(2);
  if (nummm > 4 && !savings) {
    let number = Math.ceil((num + Number.EPSILON) * 100) / 100;
    return number.toFixed(precision);
  } else if (nummm < 6 && savings) {
    let number = Math.floor((num + Number.EPSILON) * 100) / 100;
    return number.toFixed(precision);
  } else {
    let number = Math.round((num + Number.EPSILON) * 100) / 100;
    return number.toFixed(precision);
  }
}

function calculateDiscountedPrice(salePrice = 0, discount = 0) {
  if (salePrice <= 0 || discount <= 0) {
    return null;
  }
  const discountAmount = (discount / 100) * salePrice;
  const discountedPrice = salePrice - discountAmount;

  return discountedPrice;
}

/**
 * Calculates the discounted prices for a product variant based on site-wide , collection and variant specific discounts.
 *
 * @param {Object} variant - The product variant object. *
 * @returns {Object} - The discounted prices and percentages for both one-time and subscription purchases.
 */
function calculateDiscount(variant, block_type = null) {
  const isSiteWideDiscountEnabled = variant?.site_wide_discount || false;
  const siteWideDiscountValue = parseFloat(variant?.site_wide_discount_value) || 0;
  const isCollectionDiscountEnabled = variant?.collection_disc_check || false;
  const { collectionDiscount, prioritizeDiscount, discountAppliesTo, subscriptionOveride } = 
  getMaxCollectionWideDiscount(variant.collections, variant.collection_disc_check);
  let variantSubsDiscountValue = parseFloat(variant?.variant_discount_subs) || 0;
	let variantOnetimeDiscountValue = parseFloat(variant?.variant_discount_one_time) || 0;
  const ogDiscount = parseFloat(variant?.og_discount) || 0;
  const variantQtrlyDiscountValue = parseFloat(variant?.quarterly_discount_subs) || 0;

  let doesCompareAtPriceExist = false;
  let variantSalePrice = variant.price;
  if (variant.compare_at_price > variant.price) {
    variantSalePrice = variant.compare_at_price;
    doesCompareAtPriceExist = true;
  }

  const productPriceObj = {
    price: variantSalePrice,
    SUBSCRIPTION: {
      discount_price: doesCompareAtPriceExist ? variant.price : 0,
      discount_percentage: doesCompareAtPriceExist
      ? Math.round(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100)
        : 0,
      og_discount: ogDiscount,
      _debug_log: "",
    },
    ONE_TIME: {
      discount_price: doesCompareAtPriceExist ? variant.price : 0,
      discount_percentage: doesCompareAtPriceExist
      ? Math.round(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100)
        : 0,
      _debug_log: "",
    },
    ANNUAL_PREPAID: {
      discount_price: 0,
      discount_percentage: 0,
      og_discount: ogDiscount,
      _debug_log: "",
    },
  };

  if (doesCompareAtPriceExist) {
		if (!variantSubsDiscountValue) {
			variantSubsDiscountValue = getDiscountPercentage(variantSalePrice, variant.price);
		}
		if (!variantOnetimeDiscountValue) {
			variantOnetimeDiscountValue = getDiscountPercentage(variantSalePrice, variant.price);
		}
	}

  if (isSiteWideDiscountEnabled && siteWideDiscountValue) {
    productPriceObj.ONE_TIME.discount_price = calculateDiscountedPrice(variantSalePrice, siteWideDiscountValue);
    productPriceObj.ONE_TIME.discount_percentage = siteWideDiscountValue;
    productPriceObj.ONE_TIME._debug_log = `Applying sitewide discount  of ${siteWideDiscountValue}`;
    productPriceObj.SUBSCRIPTION.discount_price = calculateDiscountedPrice(variantSalePrice, siteWideDiscountValue);
    productPriceObj.SUBSCRIPTION.discount_percentage = siteWideDiscountValue;
    productPriceObj.SUBSCRIPTION._debug_log = `Applying sitewide discount  of ${siteWideDiscountValue}`;
    //productPriceObj.ANNUAL_PREPAID.discount_price = calculateDiscountedPrice(variantSalePrice, siteWideDiscountValue);
    //productPriceObj.ANNUAL_PREPAID.discount_percentage = siteWideDiscountValue;
    //productPriceObj.ANNUAL_PREPAID._debug_log = `Applying sitewide discount  of ${siteWideDiscountValue}`;
  }

  if (isCollectionDiscountEnabled && collectionDiscount) {
    const subscriptionDiscount = subscriptionOveride || collectionDiscount;
    // reset before setting collection discounts
    productPriceObj.ONE_TIME.discount_price = 0;
    productPriceObj.ONE_TIME.discount_percentage = 0;
    productPriceObj.SUBSCRIPTION.discount_price = 0;
    productPriceObj.SUBSCRIPTION.discount_percentage = 0;
    //productPriceObj.ANNUAL_PREPAID.discount_price = 0;
    //productPriceObj.ANNUAL_PREPAID.discount_percentage = 0;

    // if set true ignores site-wide
    if (prioritizeDiscount) {
      // subscription overide will always overide regardless of discountAppliesTo
      if (subscriptionOveride) {
        productPriceObj.SUBSCRIPTION.discount_price = calculateDiscountedPrice(variantSalePrice, subscriptionDiscount);
        productPriceObj.SUBSCRIPTION.discount_percentage = subscriptionDiscount;
        productPriceObj.SUBSCRIPTION._debug_log = `Applying collection priority discount ${subscriptionDiscount}`;
        //productPriceObj.ANNUAL_PREPAID.discount_price = calculateDiscountedPrice(variantSalePrice, subscriptionDiscount);
        //productPriceObj.ANNUAL_PREPAID.discount_percentage = subscriptionDiscount;
        //productPriceObj.ANNUAL_PREPAID._debug_log = `Applying collection priority discount ${subscriptionDiscount}`;
      }

      if (discountAppliesTo === "One-time" || discountAppliesTo === "One-time and Subscription") {
        productPriceObj.ONE_TIME.discount_price = calculateDiscountedPrice(variantSalePrice, collectionDiscount);
        productPriceObj.ONE_TIME.discount_percentage = collectionDiscount;
        productPriceObj.ONE_TIME._debug_log = `Applying collection priority discount ${collectionDiscount}`;
      }

      if (discountAppliesTo === "Subscription" || discountAppliesTo === "One-time and Subscription") {
        productPriceObj.SUBSCRIPTION.discount_price = calculateDiscountedPrice(variantSalePrice, subscriptionDiscount);
        productPriceObj.SUBSCRIPTION.discount_percentage = subscriptionDiscount;
        productPriceObj.SUBSCRIPTION._debug_log = `Applying collection priority discount ${subscriptionDiscount}`;
        //productPriceObj.ANNUAL_PREPAID.discount_price = calculateDiscountedPrice(variantSalePrice, subscriptionDiscount);
        //productPriceObj.ANNUAL_PREPAID.discount_percentage = subscriptionDiscount;
        //productPriceObj.ANNUAL_PREPAID._debug_log = `Applying collection priority discount ${subscriptionDiscount}`;
      }
    } else {
      // if collection discount is not prioritized compare site wide and collection wide discount and apply which one is greater
      if (siteWideDiscountValue >= collectionDiscount && isSiteWideDiscountEnabled) {
        productPriceObj.ONE_TIME.discount_price = calculateDiscountedPrice(variantSalePrice, siteWideDiscountValue);
        productPriceObj.ONE_TIME.discount_percentage = siteWideDiscountValue;
        productPriceObj.ONE_TIME._debug_log = `Applying sitewide discount  of ${siteWideDiscountValue}`;
        productPriceObj.SUBSCRIPTION.discount_price = calculateDiscountedPrice(variantSalePrice, siteWideDiscountValue);
        productPriceObj.SUBSCRIPTION.discount_percentage = siteWideDiscountValue;
        productPriceObj.SUBSCRIPTION._debug_log = `Applying sitewide discount  of ${siteWideDiscountValue}`;
        //productPriceObj.ANNUAL_PREPAID.discount_price = calculateDiscountedPrice(variantSalePrice, siteWideDiscountValue);
        //productPriceObj.ANNUAL_PREPAID.discount_percentage = siteWideDiscountValue;
        //productPriceObj.ANNUAL_PREPAID._debug_log = `Applying sitewide discount  of ${siteWideDiscountValue}`;
      } else {
        // subscription overide will always overide regardless of discountAppliesTo
        if (subscriptionOveride) {
          productPriceObj.SUBSCRIPTION.discount_price = calculateDiscountedPrice(variantSalePrice, subscriptionOveride);
					productPriceObj.SUBSCRIPTION.discount_percentage = subscriptionOveride;
          productPriceObj.SUBSCRIPTION._debug_log = `Applying collection discount ${subscriptionOveride}`;
          //productPriceObj.ANNUAL_PREPAID.discount_price = calculateDiscountedPrice(variantSalePrice, subscriptionOveride);
          //productPriceObj.ANNUAL_PREPAID.discount_percentage = subscriptionOveride;
          //productPriceObj.ANNUAL_PREPAID._debug_log = `Applying collection discount ${subscriptionOveride}`;
        }

        if (discountAppliesTo === "One-time" || discountAppliesTo === "One-time and Subscription") {
          productPriceObj.ONE_TIME.discount_price = calculateDiscountedPrice(variantSalePrice, collectionDiscount);
          productPriceObj.ONE_TIME.discount_percentage = collectionDiscount;
          productPriceObj.ONE_TIME._debug_log = `Applying collection discount ${collectionDiscount}`;
        }

        if (discountAppliesTo === "Subscription" || discountAppliesTo === "One-time and Subscription") {
          productPriceObj.SUBSCRIPTION.discount_price = calculateDiscountedPrice(
						variantSalePrice,
						subscriptionDiscount
					);
          productPriceObj.SUBSCRIPTION.discount_percentage = subscriptionDiscount;
          productPriceObj.SUBSCRIPTION._debug_log = `Applying collection discount ${subscriptionDiscount}`;
          //productPriceObj.ANNUAL_PREPAID.discount_price = calculateDiscountedPrice(variantSalePrice, subscriptionDiscount);
          //productPriceObj.ANNUAL_PREPAID.discount_percentage = subscriptionDiscount;
          //productPriceObj.ANNUAL_PREPAID._debug_log = `Applying collection discount ${subscriptionDiscount}`;
        }
      }
    }
  }

  // if(annualPrepaidDiscount){
  // 	productPriceObj.ANNUAL_PREPAID.discount_price = calculateDiscountedPrice(variantSalePrice,annualPrepaidDiscount);
  // 	productPriceObj.ANNUAL_PREPAID.discount_percentage = annualPrepaidDiscount;
  // 	productPriceObj.ANNUAL_PREPAID._debug_log = `Applying Annual Prepaid Discount ${annualPrepaidDiscount}`;
  // }

  // variant level discounts gets the highest priority
  if (variantOnetimeDiscountValue) {
    productPriceObj.ONE_TIME.discount_price = calculateDiscountedPrice(variantSalePrice, variantOnetimeDiscountValue);
    productPriceObj.ONE_TIME.discount_percentage = variantOnetimeDiscountValue;
    productPriceObj.SUBSCRIPTION._debug_log = `Applying Variant discount ${variantOnetimeDiscountValue}`;
  }

  if (variantSubsDiscountValue) {
    productPriceObj.SUBSCRIPTION.discount_price = calculateDiscountedPrice(variantSalePrice, variantSubsDiscountValue);
    productPriceObj.SUBSCRIPTION.discount_percentage = variantSubsDiscountValue;
    productPriceObj.SUBSCRIPTION._debug_log = `Applying Variant discount ${variantSubsDiscountValue}`;
    //productPriceObj.ANNUAL_PREPAID.discount_price = calculateDiscountedPrice(variantSalePrice, variantSubsDiscountValue);
    //productPriceObj.ANNUAL_PREPAID.discount_percentage = variantSubsDiscountValue;
    //productPriceObj.ANNUAL_PREPAID._debug_log = `Applying Variant discount ${variantSubsDiscountValue}`;
  }

  if (variant.selling_plan_allocations?.some(plan => plan?.selling_plan?.name?.includes('90 days') || plan?.selling_plan?.name?.includes('12 weeks')) && variantQtrlyDiscountValue && block_type === "multi_add_on_block") {
    productPriceObj.SUBSCRIPTION.discount_price = calculateDiscountedPrice(variantSalePrice, variantQtrlyDiscountValue);
    productPriceObj.SUBSCRIPTION.discount_percentage = variantQtrlyDiscountValue;
    productPriceObj.SUBSCRIPTION._debug_log = `Applying additional discount ${variantQtrlyDiscountValue}`;
  }

  // remove debug logs
  if (false) {
    delete productPriceObj.SUBSCRIPTION._debug_log;
    delete productPriceObj.ONE_TIME._debug_log;
  }
  function getDiscountPercentage(originalPrice, salePrice) {
		if (!originalPrice || originalPrice <= 0) return 0;
		return ((originalPrice - salePrice) / originalPrice) * 100;
	}

  return productPriceObj;
}

/**
 * Checks if there are any selling plans.
 *
 * This function takes an array of selling plans and returns a boolean
 * indicating whether there are any plans present.
 *
 * @param {Array} plans - An array of selling plans.
 * @returns {boolean} True if there are selling plans, false otherwise.
 */
function checkSellingPlans(plans) {
  return plans && plans.length ? true : false;
}

/**
 * Gets the maximum value discount information for a collection.
 * @param {Array<Object>} collections - The array of collection objects.
 * @param {boolean} enableCollectionDiscount - Flag to enable collection discount.
 * @returns {Object} - An object containing collection discount information.
 */
function getMaxCollectionWideDiscount(collections = [], enableCollectionDiscount) {
  if (!collections || !collections.length || !enableCollectionDiscount) {
    return {
      collectionDiscount: 0,
      prioritizeDiscount: false,
      discountAppliesTo: "One-time and Subscription",
      subscriptionOveride: 0,
    };
  }

  const collectionDiscountMetafields = collections
    .filter((c) => {
      if (c.metafields && c.metafields.hasOwnProperty("collection_discount")) {
        return c;
      }
    })
    .map((c) => {
      return {
        ...c.metafields,
        collection_discount: parseFloat(c.metafields.collection_discount),
      };
    })
    .sort((a, b) => b.collection_discount - a.collection_discount);

  if (collectionDiscountMetafields && collectionDiscountMetafields.length) {
    const currentCollectionDiscount = collectionDiscountMetafields[0];
    return {
      collectionDiscount: currentCollectionDiscount.collection_discount,
      prioritizeDiscount: currentCollectionDiscount?.prioritize_discount || false,
			discountAppliesTo: currentCollectionDiscount?.discount_applies_to[0] || "One-time and Subscription",
			subscriptionOveride: parseFloat(currentCollectionDiscount?.subscription_discount_override) || 0,
    };
  }

  return {
    collectionDiscount: 0,
    prioritizeDiscount: false,
    discountAppliesTo: "One-time and Subscription",
    subscriptionOveride: 0,
  };
}

/**
 * The function `generatePaymentOptionLabels` generates labels for payment options based on the
 * selected product and active purchase type.
 * @param {Array<Object>} selectedProduct - selectedProduct is an array containing information about the product
 * selected by the user. It seems to contain details such as product metadata, price information, and
 * discount percentages for different purchase types. The function generates payment option labels
 * based on the selected product and active purchase type.
 * @param {string} activePurchaseType - The function `generatePaymentOptionLabels` takes two parameters:
 * `selectedProduct` and `activePurchaseType`. The `selectedProduct` parameter is an array containing
 * the selected product, and the `activePurchaseType` parameter specifies the type of purchase (e.g.,
 * 'ONE_TIME' or 'RE
 * @returns {string} - An string which represents the label based on conditions selected
 */
function generatePaymentOptionLabels(selectedProduct, activePurchaseType) {
  let product = selectedProduct[0];

  // Validate product and necessary properties
  if (!product || !product.price_info || !product.price_info[activePurchaseType]) {
    return "";
  }

  if (activePurchaseType === "ONE_TIME") {
    // Product card label metafields take highest priority
    if (product.main_product && product.main_product.product_metafield_label) {
      return product.main_product.product_metafield_label
        .filter((label) => !!label.show_on_payment_block)
        .map((label) => label.title)
        .join(" ");
    }

    let discountPercentage = product.price_info[activePurchaseType].discount_percentage;
    if (discountPercentage && discountPercentage != 0) {
      return `${discountPercentage.toFixed()}% Off`;
    }
  } else if (activePurchaseType === "SUBSCRIPTION") {
    let labelStr = "";
    let saleDiscount = product.price_info[activePurchaseType].discount_percentage;
    let ogDiscount = product.price_info[activePurchaseType].og_discount;

    if (saleDiscount > 0) {
      labelStr = `${saleDiscount.toFixed()}% off now`;
    }

    if (ogDiscount && ogDiscount === saleDiscount) {
      labelStr = `${saleDiscount.toFixed()}% off now and on future orders`;
    } else if (ogDiscount && saleDiscount && ogDiscount != saleDiscount) {
      labelStr = `${saleDiscount.toFixed()}% off now, ${ogDiscount}% off on future orders`;
    } else if (saleDiscount <= 0 && ogDiscount) {
      labelStr = `${ogDiscount}% off on future orders`;
    }

    return labelStr;
  } else if (activePurchaseType === "ANNUAL_PREPAID") {
    let labelStr = "";
    let saleDiscount = product.price_info[activePurchaseType].discount_percentage;
    let ogDiscount = product.price_info[activePurchaseType].og_discount;

    if (saleDiscount > 0) {
      labelStr = `${saleDiscount.toFixed()}% off now`;
    }

    if (ogDiscount && ogDiscount === saleDiscount) {
      labelStr = `${saleDiscount.toFixed()}% off now and on future orders`;
    } else if (ogDiscount && saleDiscount && ogDiscount != saleDiscount) {
      labelStr = `${saleDiscount.toFixed()}% off now, ${ogDiscount}% off on future orders`;
    } else if (saleDiscount <= 0 && ogDiscount) {
      labelStr = `${ogDiscount}% off on future orders`;
    }

    return labelStr;
  }

  return "";
}

/**
 * Extracts the numerical value from a string containing a currency symbol.
 *
 * @param {string} currencyString - The string containing the currency value.
 * @returns {number} - The extracted numerical value as a whole number after multiplying by 100.
 */
function extractNumber(currencyString) {
  const numberString = currencyString.replace(/[^\d.-]/g, "");
  const number = parseFloat(numberString);
  return Math.round(number * 100);
}

/**
 * @typedef {Object} AddonDiscount
 * @property {string} id - The unique identifier for the discount.
 * @property {number} discount_value - The value of the discount.
 * @property {string} discount_value_type - The type of the discount, either "FIXED" or "PERCENTAGE".
 */

/**
 * Calculates the total discount percentage from an array of discount objects.
 * Fixed discount values are converted into percentages based on the base price.
 *
 * @param {AddonDiscount[]} discounts - The array of discount objects.
 * @param {number} basePrice - The base price to which fixed discounts are converted into percentages.
 * @returns {number} The total discount percentage.
 */
function calculateTotalAdnDiscount(discounts, basePrice) {
  let totalDiscountPercentage = 0;

  discounts.forEach((discount) => {
    if (discount.discount_value_type === "FIXED") {
      // Convert fixed discount to percentage
      const percentage = ((discount.discount_value * 100) / basePrice) * 100;
      totalDiscountPercentage += percentage;
    } else if (discount.discount_value_type === "PERCENTAGE") {
      totalDiscountPercentage += discount.discount_value;
    }
  });

  return totalDiscountPercentage;
}

/**
 * Returns sum of the saleprice and discount price for the given addon array
 * @param {any[]} addOns
 */
function getTotalAddonPrice(addOns) {
  let totalSalePrice = 0;
  let totalDiscountPrice = 0;

  // console.log("addOns", addOns);

	addOns.forEach((a) => {
		if (Array.isArray(a.data) && a.data.length) {
			a.data.forEach((p) => {
				if (!p.price_info) return;
				if (p.price_info.price) {
					totalSalePrice += p.price_info.price;
				}
				const purchaseType = p.purchase_type;
				if (p.price_info[purchaseType] && p.price_info[purchaseType].discount_price) {
					totalDiscountPrice += p.price_info[purchaseType].discount_price;
				}
			});
		}
	});
  return { totalSalePrice, totalDiscountPrice };
}

/**
 * This function updates the price and save labels according to the selected payment blocks
 * @param {object} headerBlock - price into state of the header block will be used to update the topline price
 * @param {string} blockType - block type of the current payment block
 */
function updateMainProductLinePrice(headerBlock, blockType) {
  const priceWrapEl = document.querySelector(".price-list.prive_price-list");
  const stickyPriceWrapEl = document.querySelector(".sticky_add_to_cart .price-list");
  const saveLabelsWrapEl = document.querySelector(".product-meta__label-list.prive-label-list");
  priceWrapEl.innerHTML = "";
  if (stickyPriceWrapEl) stickyPriceWrapEl.innerHTML = "";
  saveLabelsWrapEl.innerHTML = "";

  if (priceWrapEl) {
    const priceElement = document.createElement("span");
    priceElement.classList.add("prive_price", "price--large", "text-xl", "price-sale");

    priceElement.innerHTML =
      headerBlock.discount_price != null
        ? `<s>${formatMoneyy(headerBlock.sale_price)}</s>`
        : formatMoneyy(headerBlock.sale_price);
    priceWrapEl.appendChild(priceElement);

    // Sticky price (only if wrapper exists)
    if (stickyPriceWrapEl) {
      const stickyPriceElement = priceElement.cloneNode(true);
      stickyPriceElement.classList.replace("text-xl", "text-base");
      stickyPriceWrapEl.appendChild(stickyPriceElement);
    }

    if (headerBlock.discount_price != null) {
      const salePriceElement = document.createElement("span");
      salePriceElement.classList.add("sale_price", "price--large", "text-xl", "font-semibold", "price");
      salePriceElement.innerHTML = formatMoneyy(headerBlock.discount_price);

      priceWrapEl.appendChild(salePriceElement);

      if (stickyPriceWrapEl) {
        const stickySalePriceElement = salePriceElement.cloneNode(true);
        stickySalePriceElement.classList.replace("text-xl", "text-base");
        stickyPriceWrapEl.appendChild(stickySalePriceElement);
      }
    }
  }

  // logics for sticky product add to cart
  // if (stickyPriceWrapEl) {
  // 	const priceElement = document.createElement("span");
  // 	priceElement.classList.add("product-sticky-form__price");
  // 	priceElement.innerHTML =
  // 		headerBlock.discount_price != null
  // 			? `<s>${formatMoneyy(headerBlock.sale_price)}</s>`
  // 			: `${formatMoneyy(headerBlock.sale_price)}`;
  // 	stickyPriceWrapEl.appendChild(priceElement);

  // 	if (headerBlock.discount_price != null) {
  // 		const salePriceElement = document.createElement("span");
  // 		salePriceElement.classList.add("sticky-sale-price");
  // 		salePriceElement.style.color = "red";
  // 		salePriceElement.innerHTML = formatMoneyy(headerBlock.discount_price);
  // 		stickyPriceWrapEl.appendChild(salePriceElement);
  // 	}
  // }

  if (saveLabelsWrapEl) {
    saveLabelsWrapEl.innerHTML = "";
		const savingsArr = Array.isArray(headerBlock.savings)
      ? headerBlock.savings
      : [formatSavingsLabel(headerBlock.savings)];
    savingsArr.forEach((productLabel, index) => {
      if (!productLabel) return;
      if (Array.isArray(window.productTags)) {
				const labelTag = window.productTags.find(tag => tag.startsWith("_label:"));
				if (labelTag) {
					productLabel = labelTag.split(":")[1].trim();
				}
			}
      const saveLabelEl = `
				<span class="case-${index + 1}">
					<span dir="ltr" class="label label--highlight product-thumbnail_badge case-${index + 1}">
						<span>${productLabel}</span>
					</span>
				</span>
			`;

			saveLabelsWrapEl.innerHTML += saveLabelEl;
    });
  }
}

/**
 * Generates a savings message based on the provided savings value.
 *
 * @param {number|string} savings - The savings value, which could be a percentage or a dollar amount.
 * @returns {string|null} The savings message if savings is provided and greater than 0, otherwise null.
 */
function formatSavingsLabel(savings) {
  if (!savings) return null;
  if (!isNaN(savings)) savings = savings.toFixed(2);
  const savingsStr = savings.toString().trim();
  const hasPercentageOrDollar = /[%$]/.test(savingsStr);
  return hasPercentageOrDollar ? `SAVE ${savingsStr}` : `SAVE ${parseInt(savingsStr)}%`;
}

/**
 * Generates a savings label for addons along with main product.
 *
 * @param {string[]} labelArr - reff of current savings label array.
 * @param {any[]} addonBlockArr - reff of currently active addon block array
 * @returns {string[]} - modified savings label array with newly added labels.
 */
function getSavingsLabelForAddons(labelArr = [], addonBlockArr = []) {
  addonBlockArr.forEach((block) => {
    if (block.data[0]) {
      const selectedPurchaseType = block.data[0].purchase_type;
      const productTitle = block.data[0].variant_title;
      const discountValue = block.data[0].price_info
        ? block.data[0].price_info[selectedPurchaseType].discount_percentage
        : 0;
      if (discountValue) {
        labelArr.push(`${parseInt(discountValue)}% OFF ${productTitle}`);
      }
    }
  });

  return labelArr;
}

/**
 * Gets the additional promo labels or secondary price line from addon blocks
 * @param {string[]} labelArr - reff of current savings label array.
 * @param {any[]} addonBlockArr - reff of currently active addon block array
 * @param {object} blockData - reff of current blockdata object
 * @returns {string[]} - modified savings label array with newly added labels.
 */
function renderAdditionalPromoLabelOrPrice(labelArr = [], addonBlockArr = [], blockData) {
  addonBlockArr.forEach((block) => {
    const currentSelectedBlockData = blockData.add_ons.find((b) => b.id === block.id);
    let additionalPromoTag = currentSelectedBlockData.additional_promo_save_tag || null;
    const defaultPurchaseType = currentSelectedBlockData.default_purchase_type;
    if (block.data[0]) {
      const currentAddon = block.data[0];
      const selectedPurchaseType = currentAddon.purchase_type;
      if (additionalPromoTag && selectedPurchaseType != defaultPurchaseType) {
        if (!currentSelectedBlockData?.render_promo_as || currentSelectedBlockData.render_promo_as === "LABEL") {
          labelArr.push(additionalPromoTag);
        } else if (currentSelectedBlockData.render_promo_as === "PRICE_LINE") {
          clearSecondaryPriceLine();
          let discountValue = parseFloat(currentSelectedBlockData.subscription_discount_value);

          if (defaultPurchaseType === "ONE_TIME") {
            discountValue = parseFloat(currentSelectedBlockData.one_time_discount_value);
          }
          let mainProductMSRP = window.mainProductPrice.sale_price;
          let salePrice = calculateDiscountedPrice(mainProductMSRP, discountValue);
          let mainPriceLineEl = document.querySelector(".prive_product-meta__price-list-container");
          let secondaryPriceLineEl = document.createElement("div");
          secondaryPriceLineEl.classList.add("secondary-price");
          secondaryPriceLineEl.setAttribute("id", "secondaryPriceLine");
          let priceElStr = ``;

          if (
            blockData.price_render_mode === "DISPLAY_COMBINED_PRICE_W_DISCOUNT" ||
            blockData.price_render_mode === "DISPLAY_COMBINED_PRICE"
          ) {
            let addOnMsrpPrice = currentAddon.price_info.price;
            let addOnSalePrice = currentAddon.price_info[defaultPurchaseType].discount_price;
            mainProductMSRP += addOnMsrpPrice;
            salePrice += addOnSalePrice;
            discountValue = calculateDiscountPercentage(mainProductMSRP, salePrice);
          }

          if (mainProductMSRP) {
            priceElStr += `<span class="secondary-price__msrp-price ${salePrice ? "has-sale" : ""}">${formatMoneyy(
              mainProductMSRP
            )}</span>`;
          }
          if (salePrice) {
            priceElStr += `<span class="secondary-price__sale-price">${formatMoneyy(salePrice)}</span>`;
          }

          additionalPromoTag = additionalPromoTag.replace("${price}", priceElStr);

          if (discountValue) {
            const discountTagEl = `<span class="secondary-price__sale-tag">SAVE ${parseInt(discountValue)}%</span>`;
            additionalPromoTag = additionalPromoTag.replace("${discount_per}", discountTagEl);
          } else {
            additionalPromoTag = additionalPromoTag.replace("${discount_per}", '');
          }

          secondaryPriceLineEl.innerHTML = additionalPromoTag;

          if (mainPriceLineEl) {
            mainPriceLineEl.insertAdjacentElement("afterend", secondaryPriceLineEl);
          }
        }
      } else {
        clearSecondaryPriceLine();
      }
    }
  });
  return labelArr;
}

/**
 * Renders the additional tag on the initial mount cycle from the 1st available pay in full block
 * @param {any[]} blocks - reff of payment blocks array
 * @returns {void}
 */
function renderAdditionalTagOrPriceOnMount(blocks) {
  const saveLabelsWrapEl = document.querySelector(".product-meta__label-list.prive-label-list");
  const firstPayInFullBlock = blocks.find((b) => b.type === "pay_in_full");
  if (!firstPayInFullBlock) return;
  firstPayInFullBlock.add_ons.forEach((a) => {
    const defaultPurchaseType = a.default_purchase_type;
    let additionalPromoTag = a?.additional_promo_save_tag;
    let discountValue = parseFloat(a.subscription_discount_value);
    if (defaultPurchaseType === "ONE_TIME") {
      discountValue = parseFloat(a.one_time_discount_value);
    }

    if (a?.render_promo_as === "LABEL" && additionalPromoTag) {
      if (additionalPromoTag && discountValue) {
        const savingsLblEl = document.createElement("span");
        savingsLblEl.classList.add("label", "label--highlight");
        savingsLblEl.innerHTML = additionalPromoTag;
        saveLabelsWrapEl.appendChild(savingsLblEl);
      }
    } else if (a?.render_promo_as === "PRICE_LINE" && additionalPromoTag) {
      clearSecondaryPriceLine();
      let mainProductMSRP = window.mainProductPrice.sale_price;
      let salePrice = calculateDiscountedPrice(mainProductMSRP, discountValue);
      let mainPriceLineEl = document.querySelector(".prive_product-meta__price-list-container");
      let secondaryPriceLineEl = document.createElement("div");
      secondaryPriceLineEl.classList.add("secondary-price");
      secondaryPriceLineEl.setAttribute("id", "secondaryPriceLine");
      let priceElStr = ``;

      if (mainProductMSRP) {
        priceElStr += `<span class="secondary-price__msrp-price ${salePrice ? "has-sale" : ""}">${formatMoneyy(
          mainProductMSRP
        )}</span>`;
      }
      if (salePrice) {
        priceElStr += `<span class="secondary-price__sale-price">${formatMoneyy(salePrice)}</span>`;
      }

      additionalPromoTag = additionalPromoTag.replace("${price}", priceElStr);

      if (discountValue) {
        const discountTagEl = `<span class="secondary-price__sale-tag">SAVE ${parseInt(discountValue)}%</span>`;
       additionalPromoTag = additionalPromoTag.replace("${discount_per}", discountTagEl);
      } else {
        additionalPromoTag = additionalPromoTag.replace("${discount_per}", "");
      }

      secondaryPriceLineEl.innerHTML = additionalPromoTag;

      if (mainPriceLineEl) {
        mainPriceLineEl.insertAdjacentElement("afterend", secondaryPriceLineEl);
      }
    }
  });
}

function clearSecondaryPriceLine() {
  const existingSecondaryPriceLineEl = document.querySelector("#secondaryPriceLine");
  if (existingSecondaryPriceLineEl) {
    existingSecondaryPriceLineEl.remove();
  }
}

/**
 * Calculates the discount percentage based on the sale price and offer price.
 *
 * @param {number} salePrice - The original sale price of the item.
 * @param {number} offerPrice - The discounted offer price of the item.
 * @returns {number|null} - The integer part of the discount value, or null if inputs are invalid.
 */
function calculateDiscountPercentage(salePrice, offerPrice) {
  if (
    typeof salePrice !== "number" ||
    typeof offerPrice !== "number" ||
    salePrice <= 0 ||
    offerPrice < 0 ||
    offerPrice > salePrice
  ) {
    return null;
  }
  const discount = ((salePrice - offerPrice) / salePrice) * 100;
  return Math.round(discount);
}

/**
 * Compares the user location with blacklist and returns false if the location is part of the black list
 * @param {string[]} blacklist
 * @returns {boolean}
 */
function isUsStorefrontHost(hostname) {
  return (
    hostname === "eroma360.com" ||
    hostname === "www.eroma360.com" ||
    hostname === "localhost" ||
    hostname === "127.0.0.1" ||
    hostname.endsWith(".myshopify.com")
  );
}

function shouldRenderBlock(blacklist = []) {
  if (!isUsStorefrontHost(urlHostname) && blacklist.includes("International")) {
    return false;
  } else if (countryDomainMap && blacklist.includes(countryDomainMap.country)) {
    return false;
  }

  if (!countryDomainMap && currentGeolocation) {
    // console.log(currentGeolocation, "current geo location");
    if (currentGeolocation.country_name != "United States" && blacklist.includes("International")) {
      return false;
    } else if (blacklist.includes(currentGeolocation.country_name)) {
      return false;
    }
  }

  return true;
}


function handleize(str, frm) {
	return str
		.toLowerCase()
		.replace(/\s+/g, "-")
		.replace(/[^\w\-]+/g, "")
		.replace(/\-\-+/g, "-")
		.replace(/^-+/, "")
		.replace(/-+$/, "");
}
